   // 获取当前HTML元素的类列表
   var htmlClasses = document.documentElement.classList;

   // 检查类列表中是否包含'dark-theme'
   var isDarkTheme = htmlClasses.contains('dark-theme');

   // 根据条件设置$theme_path的值
   var $theme_path = isDarkTheme ? '/dark-theme' : '';
var personal = null;
let page = {
    characters: 1,
    storys: 1,
    characters_total: 0,
    storys_total: 0,
    characters_num: 0,
    characters_num: 0,
    favorites: 1,
    favorites_total: 0,
    favorites_num: 0,
    likes: 1,
    likes_total: 0,
    likes_num: 0,
};
var shawdow_mask = false;
var _first = true;
filtrate = 3;
nsfw = 1;
var robot_type = null, my_card_index = 0;
var report_uid;
var detail_describe;
checkLoginStatus();
if (cookie.getcookie('profile_filtrate') && window.isLoggedIn) {
    var profile_filtrate = JSON.parse(cookie.getcookie('profile_filtrate'));
    if (profile_filtrate.filtrate == 3 && profile_filtrate.openid == JSON.parse(cookie.getcookie('userInfoData')).openid) {
        filtrate = 3;
        $('.classification .genderAll i').eq(0).html('Latest');
    } else if (profile_filtrate.filtrate == 1 && profile_filtrate.openid == JSON.parse(cookie.getcookie('userInfoData')).openid) {
        filtrate = 1;
        $('.classification .genderAll i').eq(0).html('Most Popular');
    }
};
cookie.getcookie('sw') ? nsfw = cookie.getcookie('sw') : null;
if (nsfw == 1) {
    switchBoxtrue();
};

let _isRequestInProgress = false;
var mask_shawdow = false, loadSwitchBox = false;
var _first_check = true;
TagClass = ['firstTag', 'secondTag', 'thirdTag'];
(function () {
    var lisTening_login = null;
    clearInterval(lisTening_login);
    lisTening_login = setInterval(function () {
        if (!window.isLoggedIn) {
            $('.profile_follow').html(i18n[lang].public_Follow).removeClass('allowed').addClass('fit');
            clearInterval(lisTening_login);
            return;
        }
    }, 3000)
})();
$('.get_more .info_c').on('click', function () {
    $('#send_text').val($(this).html());
});
$('.faq_zoon .question').on('click', function () {
    $(this).parent().toggleClass('active').siblings('.faq_zoon').removeClass('active');
});
$('#clear_info').click(function () {
    $('.chat_text_box').html();
});
//获取用户openid
function getOpenid() {
    var _local = window.location.href.split('/account/profile/')[1];
    return (_local)
};
function addLoad() {
    if ($('#loadBox').length === 0) {
        $('.chatContent').append($(`<div id="loadBox" style="display: none;position: absolute; left: 0; right: 0; top: 0; height: 100%; z-index: 10;background: #f5f6f9;"><div class="loadanimation" style="position: absolute; top: 6.25rem; left: 50%; transform: translateX(-50%);z-index: 100;"></div></div>`))
    }
};
addLoad();
function setOtherUserInfo() {
    getAjax('/api/getOtherUserInfo', { "uid": getOpenid() }).then(response => {
        if (response.code == 200) {
            if (response.data.status == 1) {
                cookie.deletecookie('uid')
                cookie.setcookie('uid', response.data.uid, 90)
                cookie.setcookie('openid', response.data.openid, 90)
                //人物头像
                response.data.avatar_url ? $('.profile_other_img').attr({ 'src': response.data.avatar_url }) : null;
                response.data.avatar_url ? $('.other_left_h1').attr({ 'src': response.data.avatar_url }) : null;
                //人物名称
                response.data.nickname ? $('#other_user_name').html(response.data.nickname) : null;
                response.data.nickname ? $('.profile_report_zoon #profile_report_role').html(response.data.nickname) : null;
                //分享链接
                response.data.openid ? $('#share_link').html(host + 'account/profile/' + response.data.openid) : $('#share_link').html(host + 'account/profile/');
                //被人关注数
                response.data.fans_num ? $('.profile_followers').html(response.data.fans_num) : null;
                //关注别人数
                response.data.follow_num ? $('.profile_following').html(autoNumberTransform(response.data.follow_num)) : null;
                response.data.interaction ? $('.total_interactions').html(autoNumberTransform(response.data.interaction)) : null;
                response.data.introduction ? $('#profile_introduction_others').html(autoNumberTransform(response.data.introduction)) : $('#profile_introduction_others').html(i18n[lang].public_no_Introduction);
                response.data.title_icon ? iD('other_personal_metal_info').style.backgroundImage = 'url(' + response.data.title_icon + ')' : null;
                response.data.title ? iD('other_personal_metal_info').setAttribute('title', response.data.title) : null;
                response.data.title && response.data.title_icon ? iD('other_personal_metal_info').classList.add('active') : null;
                report_uid = response.data.uid;
                $('#other_personal_metal_info').on('click', function () {
                    _getAjax(_url.titleList, { uid: response.data.uid ,lang:lang}).then(res => {
                        if (res.code == 200) {
                            $('.profileMetalMask').addClass('active');
                            $('.profileMetal').addClass('active');
                            $('.profileMetal h2').html(response.data.nickname + i18n[lang].public_Achievement);
                            $('.profile_metal_list').empty();
                            $('.profileMetalInfo').remove();
                            res.data.forEach(item => {
                                $('.profile_metal_list').append(`
                                <div class="profile_metal_item" attr-id="${item.id}">
                                    <img src="${item.icon}" alt="Metal" width="100" height="100" />
                                    <p class="title metal_title">${item.title}</p>
                                </div>
                                `);
                                $('.profile_metal_container').after(`
                                <p class="profileMetalInfo">${item.desc}</p>
                                `);
                            });
                            $('.profile_metal_item').eq(0).addClass('active');
                            $('.profileMetalInfo').eq(0).addClass('active');
                            $('#profileMetalBtn').attr('attr-id', $('.profile_metal_item').eq(0).attr('attr-id')).hide();
                        } else {
                            error(i18n[lang].public_Failed_Show_Achievements)
                        }
                    });
                });
                setTimeout(function () {
                    try {
                        if (window.innerWidth <= 650 && iD('profile_introduction_others').getBoundingClientRect().height > 48) {
                            iD('profile_introduction_others').classList.add('show')
                            iD('more_introduction').classList.add('show')
                        } else {
                            iD('more_introduction').classList.remove('show')
                            iD('profile_introduction_others').classList.remove('show')
                        }
                    } catch (e) { }
                }, 10);
                if (response.data.social_links) {
                    for (var udd in response.data.social_links) {
                        iD('profile_' + udd).classList.remove('active');
                        response.data.social_links[udd] ? iD('profile_' + udd).classList.add('active') : null;
                        response.data.social_links[udd] ? iD('profile_' + udd).setAttribute('href', response.data.social_links[udd]) : null;
                    }
                };
                if (response.data.report_level == 5 || response.data.report_level == 6) {
                    $('#ProfileViolationReminder').addClass('active');
                };
                $('.violationReminder').removeClass('active');
            } else {
                $('.violationReminder').addClass('active');
            }
        } else if (response.error == 20901) {
            error(i18n[lang].error_20901);
        } else if (response.error == 20902) {
            error(i18n[lang].error_20902);
        } else if (response.error == 8001) {
            error(i18n[lang].creator_Database_Error);
        }
    });
};
setOtherUserInfo();
$(document).ready(function () {
    let TagClass = ['firstTag', 'secondTag', 'thirdTag'];
    $('.logo').on('click', function () {
        redirectToUrl(`${lang_path}/`)
    })
    if ($('#loadBox').length === 0) {
        $('.layout-content').append($('<div id="loadBox" style="display: none;position: absolute; inset: 0; z-index: 10;background: #ffffff;"><div class="loadanimation" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%);z-index: 100;"></div></div>'))
    }
    $('.layout-content #loadBox').show();
    //图片懒加载
    function loadImg(p) {
        let img = document.getElementsByClassName(p)
        const observer = new IntersectionObserver(changes => {
            //changes 是被观察的元素集合
            for (let i = 0, len = changes.length; i < len; i++) {
                let change = changes[i];
                // 通过这个属性判断是否在视口中
                if (change.isIntersecting) {
                    const imgElement = change.target;
                    imgElement.src = imgElement.getAttribute("data-avatar");
                    observer.unobserve(imgElement);
                }
            }
        })
        Array.from(img).forEach(item => observer.observe(item));
    }
    // 点赞收藏 
    var _creatFlags = false;
    function create_like(roleid, uid, status, num, element, _creatFlags) {
        var starTime = new Date().getTime();
        if (!_creatFlags) {
            _creatFlags = true;
            getAjax(_url.likesUpdate, {
                "roleid": roleid,
                "be_liked_id": uid,
                "status": status
            }).then(res => {
                const responseDate = new Date().getTime();
                if (responseDate - starTime >= 5000) {
                    _creatFlags = false;
                } else {
                    setTimeout(function () {
                        _creatFlags = false;
                    }, 5000 - (responseDate - starTime));
                };
                if (res.code == 200) {
                    if (status) {
                        num++;
                        success(i18n[lang].public_Successfully_Like)
                    } else {
                        num--;
                        success(i18n[lang].public_Successfully_Unlike);
                    }
                    element.next().html(autoNumberTransform(num));
                    element.attr('like-num', num);
                } else {
                    if (status) {
                        error(i18n[lang].public_Failed_Like)
                    } else {
                        error(i18n[lang].public_Failed_Unlike);
                    }
                }
            }).catch(res => {
                if (status) {
                    error(i18n[lang].public_Failed_Like)
                } else {
                    error(i18n[lang].public_Failed_Unlike);
                }
            });
        } else if (_creatFlags) {
            error(i18n[lang].public_too_fast);
        }
    };
    //api/getUserInfo
    getAjax(_url.getUserInfo, {
    }).then(res => {
        if (res.code == 200) {
            getAjax(`/api/getFollowStatus`, {
                "uid": getOpenid(),
            }).then(res => {
                if (res.code == 200) {
                    if (res.data.follow_status == 0) {
                        $('.profile_follow').removeClass('fit').addClass('active').removeClass('followed').addClass('allowed');
                        $('.profile_follow').html(i18n[lang].public_Follow)
                    } else {
                        $('.profile_follow').removeClass('fit').removeClass('active').addClass('followed').addClass('allowed');
                        $('.profile_follow').html(i18n[lang].public_Following)
                    }
                } else if (res.code == 204) {
                    error('Please login to follow')
                    $('.profile_follow').html(i18n[lang].public_Follow).removeClass('allowed');
                } else {
                }
            });
            if (res.data.openid == getOpenid()) {
                window.location.href = `${lang_path}/account/profile/`
            }
        } else if (res.code == 204) {

        }
        if (_first) {
            if (!shawdow_mask) {
                $('.main_right .ivu-row.chatContent').eq(0).append(`<div class="load_more big"><img src="/images${$theme_path}/sequence/logo_pad.gif" alt="Loading" /></div>`);
                $('.main_right .ivu-row.chatContent').eq(1).append(`<div class="load_more big"><img src="/images${$theme_path}/sequence/logo_pad.gif" alt="Loading" /></div>`);
                $('.main_right .ivu-row.chatContent').eq(2).append(`<div class="load_more big"><img src="/images${$theme_path}/sequence/logo_pad.gif" alt="Loading" /></div>`);
            };
            shawdow_mask = true;
            setTimeout(function () {
                //第一个盒子渲染
                getAjax(`/api/getOtherRobotsLists`, {
                    uid: getOpenid(),
                    pageNum: page.characters,
                    filtrate: filtrate,
                    nsfw: nsfw
                }).then(res => {
                    $('.main_right .ivu-row.chatContent').eq(0).find('.load_more').remove();
                    if (res.code == 200) {
                        $('.main_right .ivu-row.chatContent').eq(0).empty();
                        $('.style_card').on('click', function () {
                            $(this).addClass('active').siblings().removeClass('active');
                        });
                        if (res.data.length >= 1) {
                            // page.characters_total=res.total;
                            res.data.forEach(response => {
                                var _openid = '', _nickname = '';
                                if (response.userProfile && response.userProfile.openid) {
                                    _openid = response.userProfile.openid
                                }
                                if (response.userProfile && response.userProfile.nickname) {
                                    _nickname = response.userProfile.nickname
                                };
                                page.characters_num++;
                                var _like_num, _chats_num;
                                response.like_num ? _like_num = autoNumberTransform(response.like_num) : _like_num = 0;
                                response.chats_num ? _chats_num = autoNumberTransform(response.chats_num) : _chats_num = 0;
                                $('.main_right .ivu-row.chatContent').eq(0).append(`
                                <div class="ivu-col ivu-col-span-xxl-4 itemDiv">
                                            <a href="/chat/${response.roleid}" id="robot${response.roleid}_1" class="item homeItemInPHP robot${response.roleid}" data-roleid="${response.roleid}"> 
                                                <img src="/images/index/defaultAvatar.svg" class="img default-avatar" 
                                                    onerror="this.onerror=null; this.src='/images/index/defaultAvatar.svg';" 
                                                    data-avatar="${response.avatar_url}" alt="Character Avatar ${response.name}" width="" height="">
                                                    ${response.nsfw == 1 ? `<span class="nsfw">Unfiltered</span>` : response.nsfw == 0 ? `<span class="nsfw sfw">SFW</span>` : ''}
                                            <span audit-src="${lang_path}/character/${response.roleid}" class="name" id="name${response.roleid}">${response.name}</span>
                                            <p class="creator">by <span id="profile${response.roleid}_1" action-href="${lang_path}/account/profile/${_openid}">@${_nickname}</span>${response.userProfile && res.data.uid != response.userProfile.uid && Boolean(response.userProfile.title) ? '<img class="profile_card" src="' + response.userProfile.title_icon + '" alt="Metal" width="24" height="24" title="' + response.userProfile.title + '" attr-title_id="' + response.userProfile.title_id + '"/>' : ''}</p>
                                                <p class="desc${!response.describe || response.describe.length <= 30 ? ' notext' : ''}"
                                                title="${!response.describe || response.describe.length <= 30 ? '' : escapeHtml(response.describe)}">
                                                    ${escapeHtml(response.describe) || ''}
                                                </p>
                                                <div class="flex-col-between">
                                                    ${response.tagsid && JSON.parse(response.tagsid).length > 0 ? `
                                                        <ul class="tagsBox">
                                                            ${JSON.parse(response.tagsid).map((item, key) => `
                                                                <li class="tagsItem ${TagClass[key % TagClass.length]}">
                                                                    ${item.name}
                                                                </li>
                                                            `).join('')}
                                                        </ul>
                                                    ` : '<div class="tagsBox"></div>'}
                                                    <div class="bottom cen flex_box"> 
                                                        <div class="bottomItem">
                                                            <i class="ivu-icon iconfont svgIcon like icon-icon_like2 ${response.is_like ? 'active' : ''}" like-num="${response.like_num}"></i>
                                                            <span>${_like_num}</span>
                                                        </div> 
                                                        <div class="bottomItem">
                                                            <i class="ivu-icon iconfont icon-size svgIcon chat"></i>
                                                            <span>${_chats_num}</span>
                                                        </div> 
                                                        ${response.more_list[2].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_1"><i class=""></i><span class="report">${i18n[lang].public_Report}</span></div>` : response.more_list[1].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_1"><i class=""></i><span class="character_edit" action-href="${lang_path}/character/edit/${response.roleid}">${i18n[lang].public_Paid}</span></div>` : ''}
                                                    </div>
                                                </div>
                                            </a>
                                            </div>`)
                                const image = new Image();
                                image.src = response.avatar_url
                                image.onload = function () {
                                    var $img = $(`#robot${response.roleid}_1`).find('.img');
                                    if ($img.length) {
                                        $img.attr('src', image.src);
                                        var oAbc = $img[0].getBoundingClientRect();
                                        if (oAbc.width) {
                                            $(`#robot${response.roleid}_1 img`).attr({ 'width': oAbc.width, 'height': oAbc.height });
                                        } else {
                                            $(`#robot${response.roleid}_1 img`).attr({ 'width': image.width, 'height': image.height });
                                        }
                                    } else {
                                        console.error('Image element not found for roleid:', response.roleid);
                                    }
                                };
                                $(`#name${response.roleid}`).on('click', function (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    redirectToUrl(`${lang_path}/character/${response.roleid}`);
                                });
                                $(`#profile${response.roleid}_1`).on('click', function (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    redirectToUrl($(this).attr('action-href'));
                                });
                                $(`#robot${response.roleid}_1`).on('click', function (e) {
                                    e.preventDefault();
                                    localStorage.setItem('robotInfo', JSON.stringify({ name: response.name, tags: response.tagsid ? JSON.parse(response.tagsid) : [], greetings: response.greetings }))
                                    redirectToUrl(`/chat/${response.roleid}`)
                                });
                                $(`.other_options${response.roleid}_1`).on('click', function (e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    if ($(this).find('i').attr('class').indexOf('active') > -1) {
                                        $(this).find('i').removeClass('active').siblings().removeClass('active');
                                    } else {
                                        $(document).trigger('click');
                                        $(this).find('i').toggleClass('active').siblings().toggleClass('active');
                                    }
                                });
                                $(`.other_options${response.roleid}_1 .report`).on('click', function (e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    $(this).removeClass('active');
                                    $(`.other_options${response.roleid}_1`).find('i').removeClass('active');
                                    checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                    if (!window.isLoggedIn) {
                                        login_status()
                                    } else {
                                        report_arguments(response.roleid, response.name, response.nsfw);
                                    }
                                });
                                $(`.other_options${response.roleid}_1 .character_edit`).on('click', function (e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    $(this).removeClass('active');
                                    $(`.other_options${response.roleid}_1`).find('i').removeClass('active');
                                    checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                    if (!window.isLoggedIn) {
                                        login_status()
                                    } else {
                                        redirectToUrl($(this).attr('action-href'));
                                    }
                                });
                                $(`#robot${response.roleid}_1 .icon-icon_like2`).on('click', function (e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    var that = $(this);
                                    checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                    if (!window.isLoggedIn) {
                                        login_status()
                                    } else {
                                        that.toggleClass('active');
                                        var _num = that.attr('like-num');
                                        if (that.hasClass('active')) {
                                            create_like(response.roleid, response.userProfile.uid, 1, _num, that, _creatFlags);
                                        } else {
                                            create_like(response.roleid, response.userProfile.uid, 0, _num, that, _creatFlags);
                                        }
                                    }
                                });
                                if ($(`#robot${response.roleid}_1 .profile_card`).length > 0) {
                                    $(`#robot${response.roleid}_1 .profile_card`).on('click', function (e) {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        _getAjax(_url.titleList, { uid: response.userProfile.uid ,lang:lang}).then(res => {
                                            if (res.code == 200) {
                                                $('.profileMetalMask').addClass('active');
                                                $('.profileMetal').addClass('active');
                                                $('.profileMetal h2').html(response.userProfile.nickname + i18n[lang].public_Achievement);
                                                $('.profile_metal_list').empty();
                                                $('.profileMetalInfo').remove();
                                                res.data.forEach(item => {
                                                    $('.profile_metal_list').append(`
                                                    <div class="profile_metal_item" attr-id="${item.id}">
                                                        <img src="${item.icon}" alt="Metal" width="100" height="100" />
                                                        <p class="title metal_title">${item.title}</p>
                                                    </div>
                                                    `);
                                                    $('.profile_metal_container').after(`
                                                    <p class="profileMetalInfo">${item.desc}</p>
                                                    `);
                                                });
                                                $('.profile_metal_item').eq(0).addClass('active');
                                                $('.profileMetalInfo').eq(0).addClass('active');
                                                $('#profileMetalBtn').attr('attr-id', $('.profile_metal_item').eq(0).attr('attr-id'));
                                                if (response.userProfile.uid == JSON.parse(cookie.getcookie('userInfoData')).uid) {
                                                    $('#profileMetalBtn').hide();
                                                }
                                            } else {
                                                error(i18n[lang].public_Failed_Show_Achievements)
                                            }
                                        });
                                    });
                                }
                            });
                        } else {
                            const emptyElement = $(`
                                <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                                    <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                                    <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                                </div>
                            `)
                            $('.chatContent').eq(0).append(emptyElement);
                        }
                        addLoad();
                        setTimeout(() => {
                            page.characters++;
                            isLoading = false;
                            // if(res.data.length>1&&page.characters_total>page.characters_num){shawdow_mask=false};
                            if (res.data.length > 1) { shawdow_mask = false };
                            $('.chatContent #loadBox').hide();
                            // $('#searchInput').val('');
                            bindScroll();
                            addTooltip();
                        }, 1500)
                    } else {
                        const emptyElement = $(`
                            <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                                <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                                <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                            </div>
                        `)
                        $('.chatContent').eq(0).append(emptyElement);
                    }
                });
                //故事story渲染
                getAjax(_url.personStoryList, {
                    "uid": cookie.getcookie('uid'),
                    "type": 2,
                    "order": filtrate,
                    "page": page.storys,
                    "nsfw": nsfw
                }).then(res => {
                    $('.main_right .ivu-row.chatContent').eq(1).find('.load_more').remove();
                    if (res.code == 200) {
                        // $('.main_right .ivu-row.chatContent').eq(1).find('.innerContent').eq(0).find('.load_more').remove();
                        // $('.main_right .ivu-row.chatContent').eq(1).find('.innerContent').eq(0).empty();
                        $('.main_right .ivu-row.chatContent').eq(1).empty();
                        if (res.data.length >= 1) {
                            page.storys_total = res.total;
                            res.data.forEach(response => {
                                var _openid = '', _nickname = '';
                                if (response.userProfile && response.userProfile.openid) {
                                    _openid = response.userProfile.openid
                                }
                                if (response.userProfile && response.userProfile.nickname) {
                                    _nickname = response.userProfile.nickname
                                };
                                page.storys_num++;
                                $('.main_right .ivu-row.chatContent').eq(1).append(`
                            <div class="ivu-col ivu-col-span-xxl-4 chat-story-item itemDiv">
                                <a href="${lang_path}/character/${response.roleid}/story/${response.id}" id="robot446418_1" class="item homeItemInPHP robot446418" data-roleid="446418">
                                    <div class="story-title">${response.title}</div>
                                    <div class="story-name" id="name${response.roleid}" ><span>${i18n[lang].chat_story_Author}</span> <span class="story-user story-user_${response.id}" data-anonymoustype=${response.anonymous_type}  >${response.nickname}</span> </div>
                                    <div class="story-content"> <p>${response.beginning_content}</p> </div>
                                    <div class="story-msg">
                                        <div class="story-msg-item">${i18n[lang].public_Views} <span>${response.views}</span></div>
                                        <div class="story-msg-item">${i18n[lang].public_Likes} <span>${response.likes}</span></div>
                                        <div class="story-msg-item">${i18n[lang].public_Comment} <span>${response.comments_num}</span></div>
                                    </div>
                                </a>
                            </div>`)

                                $(`.itemDiv .story-user_${response.id}`).on('click', function (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    if ($(this).data('anonymoustype') == 1) {
                                        console.log(response.users.openid, 'response.users.openid');
                                        error(i18n[lang].public_story_anonymous)
                                    } else {
                                        redirectToUrl(`${lang_path}/account/profile/${response.users.openid}`);
                                    }
                                });

                            });
                        } else {
                            const emptyElement = $(`
                        <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                            <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                            <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_no_chat_stories}</div>
                        </div>
                    `)
                            if (!$('.chatContent').eq(1).find('.show_result').length) {
                                $('.chatContent').eq(1).append(emptyElement);
                            }
                        }
                        addLoad();
                        setTimeout(() => {
                            // story_list_page.characters++;
                            page.storys++;
                            isLoading = false;
                            // if(res.data.length>1&&page.characters_total>page.characters_num){shawdow_mask=false};
                            if (res.data.length > 1) { shawdow_mask = false };
                            $('.chatContent #loadBox').hide();
                            // $('#searchInput').val('');
                            bindScroll();
                        }, 1500)
                    } else {
                        const emptyElement = $(`
                    <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                        <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                        <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_no_chat_stories}</div>
                    </div>
                `)
                        if (!$('.chatContent').eq(1).find('.show_result').length) {
                            $('.chatContent').eq(1).append(emptyElement);
                        }
                    }
                    isRequestInProgressStory = false;
                }).catch(err => {
                    isRequestInProgressStory = false;
                });
                //收藏角色渲染
                getAjax('/api/getOtherCollectLists', {
                    "uid": getOpenid(),
                    "pageNum": page.favorites,
                    nsfw: nsfw
                }).then(res => {
                    // $('.main_right .ivu-row.chatContent').eq(2).find('.load_more').remove();
                    $('.main_right .ivu-row.chatContent').eq(2).find('.innerContent').eq(0).find('.load_more').remove();
                    if (res.code == 200) {
                        if (res.data.length >= 1) {
                            // if(res.robot_type==0||res.isdel==1){
                            // $('.main_right .ivu-row.chatContent').eq(2).empty();
                            $('.main_right .ivu-row.chatContent').eq(2).find('.innerContent').eq(0).empty();
                            // page.favorites_total=res.total;
                            res.data.forEach(response => {
                                var _openid = '', _nickname = '';
                                if (response.userProfile && response.userProfile.openid) {
                                    _openid = response.userProfile.openid
                                }
                                if (response.userProfile && response.userProfile.nickname) {
                                    _nickname = response.userProfile.nickname
                                };
                                page.favorites_num++;
                                var _like_num, _chats_num;
                                response.like_num ? _like_num = autoNumberTransform(response.like_num) : _like_num = 0;
                                response.chats_num ? _chats_num = autoNumberTransform(response.chats_num) : _chats_num = 0;
                                $('.main_right .ivu-row.chatContent').eq(2).find('.innerContent').eq(0).append(`
                                <div class="ivu-col ivu-col-span-xxl-4 itemDiv">
                                <a href="/chat/${response.roleid}" id="robot${response.roleid}_4" class="item homeItemInPHP robot${response.roleid}" data-roleid="${response.roleid}"> 
                                                <img src="/images/index/defaultAvatar.svg" class="img default-avatar" 
                                                    onerror="this.onerror=null; this.src='/images/index/defaultAvatar.svg';" 
                                                    data-avatar="${response.avatar_url}" alt="Character Avatar ${response.name}" width="" height="">
                                                    ${response.nsfw == 1 ? `<span class="nsfw">Unfiltered</span>` : response.nsfw == 0 ? `<span class="nsfw sfw">SFW</span>` : ''}
                                            <span audit-src="${lang_path}/character/${response.roleid}" class="name" id="name${response.roleid}">${response.name}</span>
                                            <p class="creator">by <span id="profile${response.roleid}_4" action-href="${lang_path}/account/profile/${_openid}">@${_nickname}</span>${response.userProfile && res.data.uid != response.userProfile.uid && Boolean(response.userProfile.title) ? '<img class="profile_card" src="' + response.userProfile.title_icon + '" alt="Metal" width="24" height="24" title="' + response.userProfile.title + '" attr-title_id="' + response.userProfile.title_id + '"/>' : ''}</p>
                                                <p class="desc${!response.describe || response.describe.length <= 30 ? ' notext' : ''}"
                                                title="${!response.describe || response.describe.length <= 30 ? '' : escapeHtml(response.describe)}">
                                                    ${escapeHtml(response.describe) || ''}
                                                </p>
                                                <div class="flex-col-between">
                                                    ${response.tagsid && JSON.parse(response.tagsid).length > 0 ? `
                                                        <ul class="tagsBox">
                                                            ${JSON.parse(response.tagsid).map((item, key) => `
                                                                <li class="tagsItem ${TagClass[key % TagClass.length]}">
                                                                    ${item.name}
                                                                </li>
                                                            `).join('')}
                                                        </ul>
                                                    ` : '<div class="tagsBox"></div>'}
                                                    <div class="bottom cen flex_box"> 
                                                        <div class="bottomItem">
                                                            <i class="ivu-icon iconfont svgIcon like icon-icon_like2 ${response.is_like ? 'active' : ''}" like-num="${response.like_num}"></i>
                                                            <span>${_like_num}</span>
                                                        </div> 
                                                        <div class="bottomItem">
                                                            <i class="ivu-icon iconfont icon-size svgIcon chat"></i>
                                                            <span>${_chats_num}</span>
                                                        </div> 
                                                        ${response.more_list[2].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_4"><i class=""></i><span class="report">${i18n[lang].public_Report}</span></div>` : response.more_list[1].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_4"><i class=""></i><span class="character_edit" action-href="${lang_path}/character/edit/${response.roleid}">${i18n[lang].public_Paid}</span></div>` : ''}
                                                    </div>
                                                </div>
                                            </a>
                                            </div>`)
                                const image = new Image();
                                image.src = response.avatar_url
                                image.onload = function () {
                                    var $img = $(`#robot${response.roleid}_4`).find('.img');
                                    if ($img.length) {
                                        $img.attr('src', image.src);
                                        var oAbc = $img[0].getBoundingClientRect();
                                        if (oAbc.width) {
                                            $(`#robot${response.roleid}_4 img`).attr({ 'width': oAbc.width, 'height': oAbc.height });
                                        } else {
                                            $(`#robot${response.roleid}_4 img`).attr({ 'width': image.width, 'height': image.height });
                                        }
                                    } else {
                                        console.error('Image element not found for roleid:', response.roleid);
                                    }
                                };
                                $(`#name${response.roleid}`).on('click', function (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    redirectToUrl(`${lang_path}/character/${response.roleid}`);
                                });
                                $(`#profile${response.roleid}_4`).on('click', function (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    redirectToUrl($(this).attr('action-href'));
                                });
                                $(`#robot${response.roleid}_4`).on('click', function (e) {
                                    e.preventDefault();
                                    localStorage.setItem('robotInfo', JSON.stringify({ name: response.name, tags: response.tagsid ? JSON.parse(response.tagsid) : [], greetings: response.greetings }))
                                    redirectToUrl(`/chat/${response.roleid}`)
                                });
                                $(`.other_options${response.roleid}_4`).on('click', function (e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    if ($(this).find('i').attr('class').indexOf('active') > -1) {
                                        $(this).find('i').removeClass('active').siblings().removeClass('active');
                                    } else {
                                        $(document).trigger('click');
                                        $(this).find('i').toggleClass('active').siblings().toggleClass('active');
                                    }
                                });
                                $(`.other_options${response.roleid}_4 .report`).on('click', function (e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    $(this).removeClass('active');
                                    $(`.other_options${response.roleid}_4`).find('i').removeClass('active');
                                    checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                    if (!window.isLoggedIn) {
                                        login_status()
                                    } else {
                                        report_arguments(response.roleid, response.name, response.nsfw);
                                    }
                                });
                                $(`.other_options${response.roleid}_4 .character_edit`).on('click', function (e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    $(this).removeClass('active');
                                    $(`.other_options${response.roleid}_4`).find('i').removeClass('active');
                                    checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                    if (!window.isLoggedIn) {
                                        login_status()
                                    } else {
                                        redirectToUrl($(this).attr('action-href'));
                                    }
                                });
                                $(`#robot${response.roleid}_4 .icon-icon_like2`).on('click', function (e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    var that = $(this);
                                    checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                    if (!window.isLoggedIn) {
                                        login_status()
                                    } else {
                                        that.toggleClass('active');
                                        var _num = that.attr('like-num');
                                        if (that.hasClass('active')) {
                                            create_like(response.roleid, response.userProfile.uid, 1, _num, that, _creatFlags);
                                        } else {
                                            create_like(response.roleid, response.userProfile.uid, 0, _num, that, _creatFlags);
                                        }
                                    }
                                });
                                if ($(`#robot${response.roleid}_4 .profile_card`).length > 0) {
                                    $(`#robot${response.roleid}_4 .profile_card`).on('click', function (e) {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        _getAjax(_url.titleList, { uid: response.userProfile.uid ,lang:lang}).then(res => {
                                            if (res.code == 200) {
                                                $('.profileMetalMask').addClass('active');
                                                $('.profileMetal').addClass('active');
                                                $('.profileMetal h2').html(response.userProfile.nickname + i18n[lang].public_Achievement);
                                                $('.profile_metal_list').empty();
                                                $('.profileMetalInfo').remove();
                                                res.data.forEach(item => {
                                                    $('.profile_metal_list').append(`
                                                    <div class="profile_metal_item" attr-id="${item.id}">
                                                        <img src="${item.icon}" alt="Metal" width="100" height="100" />
                                                        <p class="title metal_title">${item.title}</p>
                                                    </div>
                                                    `);
                                                    $('.profile_metal_container').after(`
                                                    <p class="profileMetalInfo">${item.desc}</p>
                                                    `);
                                                });
                                                $('.profile_metal_item').eq(0).addClass('active');
                                                $('.profileMetalInfo').eq(0).addClass('active');
                                                $('#profileMetalBtn').attr('attr-id', $('.profile_metal_item').eq(0).attr('attr-id'));
                                                if (response.userProfile.uid == JSON.parse(cookie.getcookie('userInfoData')).uid) {
                                                    $('#profileMetalBtn').hide();
                                                }
                                            } else {
                                                error(i18n[lang].public_Failed_Show_Achievements)
                                            }
                                        });
                                    });
                                }
                            });
                            // }
                        } else {
                            const emptyElement = $(`
                                <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                                    <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                                    <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                                </div>
                            `)
                            // $('.chatContent').eq(2).append(emptyElement);
                            if (!$('.chatContent').eq(2).find('.show_result').length) {
                                $('.chatContent').eq(2).find('.innerContent').eq(0).append(emptyElement);
                            }
                        }
                        addLoad();
                        setTimeout(() => {
                            page.favorites++;
                            isLoading = false;
                            // if(res.data.length>1&&page.favorites_total>page.favorites_num){shawdow_mask=false};
                            if (res.data.length > 1) { shawdow_mask = false };
                            $('.chatContent #loadBox').hide();
                            // $('#searchInput').val('');
                            bindScroll();
                            addTooltip();
                        }, 1500)
                    } else if (res.code == 2304) {
                        const emptyElement = $(`
                        <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                            <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                            <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                        </div>
                    `)
                        if (!$('.chatContent').eq(2).find('.show_result').length) {
                            $('.chatContent').eq(2).find('.innerContent').eq(0).append(emptyElement);
                        }
                    } else {
                        const emptyElement = $(`
                            <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                                <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                                <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                            </div>
                        `)
                        if (!$('.chatContent').eq(2).find('.show_result').length) {
                            $('.chatContent').eq(2).find('.innerContent').eq(0).append(emptyElement);
                        }
                    }
                });
                //收藏story渲染
                getAjax(_url.getStoryCollectList, {
                    "uid": cookie.getcookie('uid'),
                    "pageNum": 1,
                }).then(res => {
                    $('.main_right .ivu-row.chatContent').eq(2).find('.load_more').remove();
                    if (res.code == 200) {
                        $('.main_right .ivu-row.chatContent').eq(2).find('.innerContent').eq(1).find('.load_more').remove();
                        $('.main_right .ivu-row.chatContent').eq(2).find('.innerContent').eq(1).empty();
                        $('.style_card').on('click', function () {
                            $(this).addClass('active').siblings().removeClass('active');
                        });
                        if (res.data.length >= 1) {
                            // page.characters_total=res.total;
                            res.data.forEach(response => {
                                var _openid = '', _nickname = '';
                                if (response.userProfile && response.userProfile.openid) {
                                    _openid = response.userProfile.openid
                                }
                                if (response.userProfile && response.userProfile.nickname) {
                                    _nickname = response.userProfile.nickname
                                };
                                // page.characters_num++;
                                $('.main_right .ivu-row.chatContent').eq(2).find('.innerContent').eq(1).append(`
                                <div class="ivu-col ivu-col-span-xxl-4 chat-story-item itemDiv">
                                    <a href="${lang_path}/character/${response.roleid}/story/${response.id}" id="robot446418_1" class="item homeItemInPHP robot446418" data-roleid="446418">
                                        <div class="story-title">${response.title}</div>
                                        <div class="story-name" id="name${response.roleid}" ><span>${i18n[lang].chat_story_Author}</span> <span class="story-user story-user_${response.id}" data-anonymoustype=${response.anonymous_type}  >${response.nickname}</span> </div>
                                        <div class="story-content"> <p>${response.beginning_content}</p> </div>
                                        <div class="story-msg">
                                            <div class="story-msg-item">${i18n[lang].public_Views} <span>${response.views}</span></div>
                                            <div class="story-msg-item">${i18n[lang].public_Likes} <span>${response.likes}</span></div>
                                            <div class="story-msg-item">${i18n[lang].public_Comment} <span>${response.comments_num}</span></div>
                                        </div>
                                    </a>
                                </div>`)

                                $(`.itemDiv .story-user_${response.id}`).on('click', function (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    if ($(this).data('anonymoustype') == 1) {
                                        console.log(response.users.openid, 'response.users.openid');
                                        error(i18n[lang].public_story_anonymous)
                                    } else {
                                        redirectToUrl(`${lang_path}/account/profile/${response.users.openid}`);
                                    }
                                });

                            });
                        } else {
                            const emptyElement = $(`
                            <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                                <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                                <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_no_chat_stories}</div>
                            </div>
                        `)
                            if (!$('.favorites-content .innerContent').eq(1).find('.show_result').length) {
                                $('.favorites-content .innerContent').eq(1).append(emptyElement);
                            }
                        }
                        addLoad();
                        setTimeout(() => {
                            // story_list_page.characters++;
                            isLoading = false;
                            // if(res.data.length>1&&page.characters_total>page.characters_num){shawdow_mask=false};
                            if (res.data.length > 1) { shawdow_mask = false };
                            $('.chatContent #loadBox').hide();
                            // $('#searchInput').val('');
                            bindScroll();
                        }, 1500)
                    } else {
                        const emptyElement = $(`
                        <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                            <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                            <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_no_chat_stories}</div>
                        </div>
                    `)
                        if (!$('.favorites-content .innerContent').eq(1).find('.show_result').length) {
                            $('.favorites-content .innerContent').eq(1).append(emptyElement);
                        }
                    }
                    isRequestInProgressStory = false;
                }).catch(err => {
                    isRequestInProgressStory = false;
                });
                //喜欢角色渲染
                getAjax('/api/getOtherLikesLists', {
                    "uid": getOpenid(),
                    "pageNum": page.likes,
                    nsfw: nsfw
                }).then(res => {
                    // $('.main_right .ivu-row.chatContent').eq(2).find('.load_more').remove();
                    $('.main_right .ivu-row.chatContent').eq(3).find('.innerContent').eq(0).find('.load_more').remove();
                    if (res.code == 200) {
                        if (res.data.length >= 1) {
                            // if(res.robot_type==0||res.isdel==1){
                            // $('.main_right .ivu-row.chatContent').eq(2).empty();
                            $('.main_right .ivu-row.chatContent').eq(3).find('.innerContent').eq(0).empty();
                            // page.likes_total=res.total;
                            res.data.forEach(response => {
                                var _openid = '', _nickname = '';
                                if (response.userProfile && response.userProfile.openid) {
                                    _openid = response.userProfile.openid
                                }
                                if (response.userProfile && response.userProfile.nickname) {
                                    _nickname = response.userProfile.nickname
                                };
                                page.likes_num++;
                                var _like_num, _chats_num;
                                response.like_num ? _like_num = autoNumberTransform(response.like_num) : _like_num = 0;
                                response.chats_num ? _chats_num = autoNumberTransform(response.chats_num) : _chats_num = 0;
                                // $('.main_right .ivu-row.chatContent').eq(2).append(`
                                $('.main_right .ivu-row.chatContent').eq(3).find('.innerContent').eq(0).append(`
                                <div class="ivu-col ivu-col-span-xxl-4 itemDiv">
                                <a href="/chat/${response.roleid}" id="robot${response.roleid}_5" class="item homeItemInPHP robot${response.roleid}" data-roleid="${response.roleid}"> 
                                                <img src="/images/index/defaultAvatar.svg" class="img default-avatar" 
                                                    onerror="this.onerror=null; this.src='/images/index/defaultAvatar.svg';" 
                                                    data-avatar="${response.avatar_url}" alt="Character Avatar ${response.name}" width="" height="">
                                                    ${response.nsfw == 1 ? `<span class="nsfw">Unfiltered</span>` : response.nsfw == 0 ? `<span class="nsfw sfw">SFW</span>` : ''}
                                            <span audit-src="${lang_path}/character/${response.roleid}" class="name" id="name${response.roleid}">${response.name}</span>
                                            <p class="creator">by <span id="profile${response.roleid}_5" action-href="${lang_path}/account/profile/${_openid}">@${_nickname}</span>${response.userProfile && res.data.uid != response.userProfile.uid && Boolean(response.userProfile.title) ? '<img class="profile_card" src="' + response.userProfile.title_icon + '" alt="Metal" width="24" height="24" title="' + response.userProfile.title + '" attr-title_id="' + response.userProfile.title_id + '"/>' : ''}</p>
                                                <p class="desc${!response.describe || response.describe.length <= 30 ? ' notext' : ''}"
                                                title="${!response.describe || response.describe.length <= 30 ? '' : escapeHtml(response.describe)}">
                                                    ${escapeHtml(response.describe) || ''}
                                                </p>
                                                <div class="flex-col-between">
                                                    ${response.tagsid && JSON.parse(response.tagsid).length > 0 ? `
                                                        <ul class="tagsBox">
                                                            ${JSON.parse(response.tagsid).map((item, key) => `
                                                                <li class="tagsItem ${TagClass[key % TagClass.length]}">
                                                                    ${item.name}
                                                                </li>
                                                            `).join('')}
                                                        </ul>
                                                    ` : '<div class="tagsBox"></div>'}
                                                    <div class="bottom cen flex_box"> 
                                                        <div class="bottomItem">
                                                            <i class="ivu-icon iconfont svgIcon like icon-icon_like2 ${response.is_like ? 'active' : ''}" like-num="${response.like_num}"></i>
                                                            <span>${_like_num}</span>
                                                        </div> 
                                                        <div class="bottomItem">
                                                            <i class="ivu-icon iconfont icon-size svgIcon chat"></i>
                                                            <span>${_chats_num}</span>
                                                        </div> 
                                                        ${response.more_list[2].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_5"><i class=""></i><span class="report">${i18n[lang].public_Report}</span></div>` : response.more_list[1].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_5"><i class=""></i><span class="character_edit" action-href="${lang_path}/character/edit/${response.roleid}">${i18n[lang].public_Paid}</span></div>` : ''}
                                                    </div>
                                                </div>
                                            </a>
                                            </div>`)
                                const image = new Image();
                                image.src = response.avatar_url
                                image.onload = function () {
                                    var $img = $(`#robot${response.roleid}_5`).find('.img');
                                    if ($img.length) {
                                        $img.attr('src', image.src);
                                        var oAbc = $img[0].getBoundingClientRect();
                                        if (oAbc.width) {
                                            $(`#robot${response.roleid}_5 img`).attr({ 'width': oAbc.width, 'height': oAbc.height });
                                        } else {
                                            $(`#robot${response.roleid}_5 img`).attr({ 'width': image.width, 'height': image.height });
                                        }
                                    } else {
                                        console.error('Image element not found for roleid:', response.roleid);
                                    }
                                };
                                $(`#name${response.roleid}`).on('click', function (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    redirectToUrl(`${lang_path}/character/${response.roleid}`);
                                });
                                $(`#profile${response.roleid}_5`).on('click', function (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    redirectToUrl($(this).attr('action-href'));
                                });
                                $(`#robot${response.roleid}_5`).on('click', function (e) {
                                    e.preventDefault();
                                    localStorage.setItem('robotInfo', JSON.stringify({ name: response.name, tags: response.tagsid ? JSON.parse(response.tagsid) : [], greetings: response.greetings }))
                                    redirectToUrl(`/chat/${response.roleid}`)
                                });
                                $(`.other_options${response.roleid}_5`).on('click', function (e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    if ($(this).find('i').attr('class').indexOf('active') > -1) {
                                        $(this).find('i').removeClass('active').siblings().removeClass('active');
                                    } else {
                                        $(document).trigger('click');
                                        $(this).find('i').toggleClass('active').siblings().toggleClass('active');
                                    }
                                });
                                $(`.other_options${response.roleid}_5 .report`).on('click', function (e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    $(this).removeClass('active');
                                    $(`.other_options${response.roleid}_5`).find('i').removeClass('active');
                                    checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                    if (!window.isLoggedIn) {
                                        login_status()
                                    } else {
                                        report_arguments(response.roleid, response.name, response.nsfw);
                                    }
                                });
                                $(`.other_options${response.roleid}_5 .character_edit`).on('click', function (e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    $(this).removeClass('active');
                                    $(`.other_options${response.roleid}_5`).find('i').removeClass('active');
                                    checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                    if (!window.isLoggedIn) {
                                        login_status()
                                    } else {
                                        redirectToUrl($(this).attr('action-href'));
                                    }
                                });
                                $(`#robot${response.roleid}_5 .icon-icon_like2`).on('click', function (e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    var that = $(this);
                                    checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                    if (!window.isLoggedIn) {
                                        login_status()
                                    } else {
                                        that.toggleClass('active');
                                        var _num = that.attr('like-num');
                                        if (that.hasClass('active')) {
                                            create_like(response.roleid, response.userProfile.uid, 1, _num, that, _creatFlags);
                                        } else {
                                            create_like(response.roleid, response.userProfile.uid, 0, _num, that, _creatFlags);
                                        }
                                    }
                                });
                                if ($(`#robot${response.roleid}_5 .profile_card`).length > 0) {
                                    $(`#robot${response.roleid}_5 .profile_card`).on('click', function (e) {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        _getAjax(_url.titleList, { uid: response.userProfile.uid ,lang:lang}).then(res => {
                                            if (res.code == 200) {
                                                $('.profileMetalMask').addClass('active');
                                                $('.profileMetal').addClass('active');
                                                $('.profileMetal h2').html(response.userProfile.nickname + i18n[lang].public_Achievement);
                                                $('.profile_metal_list').empty();
                                                $('.profileMetalInfo').remove();
                                                res.data.forEach(item => {
                                                    $('.profile_metal_list').append(`
                                                    <div class="profile_metal_item" attr-id="${item.id}">
                                                        <img src="${item.icon}" alt="Metal" width="100" height="100" />
                                                        <p class="title metal_title">${item.title}</p>
                                                    </div>
                                                    `);
                                                    $('.profile_metal_container').after(`
                                                    <p class="profileMetalInfo">${item.desc}</p>
                                                    `);
                                                });
                                                $('.profile_metal_item').eq(0).addClass('active');
                                                $('.profileMetalInfo').eq(0).addClass('active');
                                                $('#profileMetalBtn').attr('attr-id', $('.profile_metal_item').eq(0).attr('attr-id'));
                                                if (response.userProfile.uid == JSON.parse(cookie.getcookie('userInfoData')).uid) {
                                                    $('#profileMetalBtn').hide();
                                                }
                                            } else {
                                                error(i18n[lang].public_Failed_Show_Achievements)
                                            }
                                        });
                                    });
                                }
                            });
                            // }
                        } else {
                            const emptyElement = $(`
                                <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                                    <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                                    <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                                </div>
                            `)
                            if (!$('.chatContent').eq(3).find('.show_result').length) {
                                $('.chatContent').eq(3).find('.innerContent').eq(0).append(emptyElement);
                            }
                        }
                        addLoad();
                        setTimeout(() => {
                            page.likes++;
                            isLoading = false;
                            // if(res.data.length>1&&page.likes_total>page.likes_num){shawdow_mask=false};
                            if (res.data.length > 1) { shawdow_mask = false };
                            $('.chatContent #loadBox').hide();
                            // $('#searchInput').val('');
                            bindScroll();
                            addTooltip();
                        }, 1500)
                    } else if (res.code == 2304) {
                        const emptyElement = $(`
                        <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                            <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                            <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                        </div>
                    `)
                        $('.chatContent').eq(3).find('.innerContent').eq(0).append(emptyElement);
                    } else {
                        const emptyElement = $(`
                            <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                                <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                                <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                            </div>
                        `)
                        $('.chatContent').eq(3).find('.innerContent').eq(0).append(emptyElement);
                    }
                });
                //喜欢story渲染
                getAjax(_url.likeStoryList, {
                    "uid": cookie.getcookie('uid'),
                    "type": 2,
                    "order": filtrate,
                    "page": 1,
                }).then(res => {
                    $('.main_right .ivu-row.chatContent').eq(3).find('.load_more').remove();
                    if (res.code == 200) {
                        $('.main_right .ivu-row.chatContent').eq(3).find('.innerContent').eq(1).find('.load_more').remove();
                        $('.main_right .ivu-row.chatContent').eq(3).find('.innerContent').eq(1).empty();
                        $('.style_card').on('click', function () {
                            $(this).addClass('active').siblings().removeClass('active');
                        });
                        if (res.data.length >= 1) {
                            // page.characters_total=res.total;
                            res.data.forEach(response => {
                                var _openid = '', _nickname = '';
                                if (response.userProfile && response.userProfile.openid) {
                                    _openid = response.userProfile.openid
                                }
                                if (response.userProfile && response.userProfile.nickname) {
                                    _nickname = response.userProfile.nickname
                                };
                                // page.characters_num++;
                                $('.main_right .ivu-row.chatContent').eq(3).find('.innerContent').eq(1).append(`
                            <div class="ivu-col ivu-col-span-xxl-4 chat-story-item itemDiv">
                                <a href="${lang_path}/character/${response.roleid}/story/${response.id}" id="robot446418_1" class="item homeItemInPHP robot446418" data-roleid="446418">
                                    <div class="story-title">${response.title}</div>
                                    <div class="story-name" id="name${response.roleid}" ><span>${i18n[lang].chat_story_Author}</span> <span class="story-user story-user_${response.id}" data-anonymoustype=${response.anonymous_type}  >${response.nickname}</span> </div>
                                    <div class="story-content"> <p>${response.beginning_content}</p> </div>
                                    <div class="story-msg">
                                        <div class="story-msg-item">${i18n[lang].public_Views} <span>${response.views}</span></div>
                                        <div class="story-msg-item">${i18n[lang].public_Likes} <span>${response.likes}</span></div>
                                        <div class="story-msg-item">${i18n[lang].public_Comment} <span>${response.comments_num}</span></div>
                                    </div>
                                </a>
                            </div>`)

                                $(`.itemDiv .story-user_${response.id}`).on('click', function (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    if ($(this).data('anonymoustype') == 1) {
                                        console.log(response.users.openid, 'response.users.openid');
                                        error(i18n[lang].public_story_anonymous)
                                    } else {
                                        redirectToUrl(`${lang_path}/account/profile/${response.users.openid}`);
                                    }
                                });

                            });
                        } else {
                            const emptyElement = $(`
                        <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                            <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                            <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_no_chat_stories}</div>
                        </div>
                    `)
                            if (!$('.likes-content .innerContent').eq(1).find('.show_result').length) {
                                $('.likes-content .innerContent').eq(1).append(emptyElement);
                            }
                        }
                        addLoad();
                        setTimeout(() => {
                            // story_list_page.characters++;
                            isLoading = false;
                            // if(res.data.length>1&&page.characters_total>page.characters_num){shawdow_mask=false};
                            if (res.data.length > 1) { shawdow_mask = false };
                            $('.chatContent #loadBox').hide();
                            // $('#searchInput').val('');
                            bindScroll();
                        }, 1500)
                    } else {
                        const emptyElement = $(`
                    <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                        <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                        <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_no_chat_stories}</div>
                    </div>
                `)
                        if (!$('.likes-content .innerContent').eq(1).find('.show_result').length) {
                            $('.likes-content .innerContent').eq(1).append(emptyElement);
                        }
                    }
                    isRequestInProgressStory = false;
                }).catch(err => {
                    isRequestInProgressStory = false;
                });
                _first = false;
            }, 3000);
        }
    });

    let isLoading = false;
    function loadMore() {
        if (isLoading) return;
        isLoading = true;
        if ($('.my_card').eq(0).attr('class').indexOf('active') > -1) {
            if ($('.chatContent.active .itemDiv').length < 20) {
                $('.load_more').remove(); return;
            } else {
                if (!shawdow_mask) { $('.main_right .ivu-row.chatContent').eq(0).append(`<div class="load_more"><img src="/images${$theme_path}/sequence/logo_pad.gif" alt="Loading" /></div>`); }
                shawdow_mask = true;
                getAjax('/api/getOtherRobotsLists', {
                    "uid": getOpenid(),
                    "pageNum": page.characters,
                    nsfw: nsfw
                }).then(res => {
                    if (res.code == 200) {
                        $('.load_more').remove();
                        // page.characters_total=res.total;
                        res.data.forEach(response => {
                            var _openid = '', _nickname = '';
                            if (response.userProfile && response.userProfile.openid) {
                                _openid = response.userProfile.openid
                            }
                            if (response.userProfile && response.userProfile.nickname) {
                                _nickname = response.userProfile.nickname
                            };
                            page.characters_num++;
                            var _like_num, _chats_num;
                            response.like_num ? _like_num = autoNumberTransform(response.like_num) : _like_num = 0;
                            response.chats_num ? _chats_num = autoNumberTransform(response.chats_num) : _chats_num = 0;
                            $('.main_right .ivu-row.chatContent').eq(0).append(`
                      <div class="ivu-col ivu-col-span-xxl-4 itemDiv">
                      <a href="/chat/${response.roleid}" id="robot${response.roleid}_1" class="item homeItemInPHP robot${response.roleid}" data-roleid="${response.roleid}"> 
                                    <img src="/images/index/defaultAvatar.svg" class="img default-avatar" 
                                        onerror="this.onerror=null; this.src='/images/index/defaultAvatar.svg';" 
                                        data-avatar="${response.avatar_url}" alt="Character Avatar ${response.name}" width="" height="">
                                        ${response.nsfw == 1 ? `<span class="nsfw">Unfiltered</span>` : response.nsfw == 0 ? `<span class="nsfw sfw">SFW</span>` : ''}
                                <span audit-src="${lang_path}/character/${response.roleid}" class="name" id="name${response.roleid}">${response.name}</span>
                                <p class="creator">by <span id="profile${response.roleid}_1" action-href="${lang_path}/account/profile/${_openid}">@${_nickname}</span>${response.userProfile && res.data.uid != response.userProfile.uid && Boolean(response.userProfile.title) ? '<img class="profile_card" src="' + response.userProfile.title_icon + '" alt="Metal" width="24" height="24" title="' + response.userProfile.title + '" attr-title_id="' + response.userProfile.title_id + '"/>' : ''}</p>
                                    <p class="desc${!response.describe || response.describe.length <= 30 ? ' notext' : ''}"
                                    title="${!response.describe || response.describe.length <= 30 ? '' : escapeHtml(response.describe)}">
                                        ${escapeHtml(response.describe) || ''}
                                    </p>
                                    <div class="flex-col-between">
                                        ${response.tagsid && JSON.parse(response.tagsid).length > 0 ? `
                                            <ul class="tagsBox">
                                                ${JSON.parse(response.tagsid).map((item, key) => `
                                                    <li class="tagsItem ${TagClass[key % TagClass.length]}">
                                                        ${item.name}
                                                    </li>
                                                `).join('')}
                                            </ul>
                                        ` : '<div class="tagsBox"></div>'}
                                        <div class="bottom cen flex_box"> 
                                            <div class="bottomItem">
                                                <i class="ivu-icon iconfont svgIcon like icon-icon_like2 ${response.is_like ? 'active' : ''}" like-num="${response.like_num}"></i>
                                                <span>${_like_num}</span>
                                            </div> 
                                            <div class="bottomItem">
                                                <i class="ivu-icon iconfont icon-size svgIcon chat"></i>
                                                <span>${_chats_num}</span>
                                            </div> 
                                            ${response.more_list[2].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_1"><i class=""></i><span class="report">${i18n[lang].public_Report}</span></div>` : response.more_list[1].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_1"><i class=""></i><span class="character_edit" action-href="${lang_path}/character/edit/${response.roleid}">${i18n[lang].public_Paid}</span></div>` : ''}
                                        </div>
                                    </div>
                                </a>
                                </div>`)
                            const image = new Image();
                            image.src = response.avatar_url
                            image.onload = function () {
                                var $img = $(`#robot${response.roleid}_1`).find('.img');
                                if ($img.length) {
                                    $img.attr('src', image.src);
                                    var oAbc = $img[0].getBoundingClientRect();
                                    if (oAbc.width) {
                                        $(`#robot${response.roleid}_1 img`).attr({ 'width': oAbc.width, 'height': oAbc.height });
                                    } else {
                                        $(`#robot${response.roleid}_1 img`).attr({ 'width': image.width, 'height': image.height });
                                    }
                                } else {
                                    console.error('Image element not found for roleid:', response.roleid);
                                }
                            };
                            $(`#name${response.roleid}`).on('click', function (e) {
                                e.preventDefault();
                                e.stopPropagation();
                                redirectToUrl(`${lang_path}/character/${response.roleid}`);
                            });
                            $(`#profile${response.roleid}_1`).on('click', function (e) {
                                e.preventDefault();
                                e.stopPropagation();
                                redirectToUrl($(this).attr('action-href'));
                            });
                            $(`#robot${response.roleid}_1`).on('click', function (e) {
                                e.preventDefault();
                                localStorage.setItem('robotInfo', JSON.stringify({ name: response.name, tags: response.tagsid ? JSON.parse(response.tagsid) : [], greetings: response.greetings }))
                                redirectToUrl(`/chat/${response.roleid}`)
                            });
                            $(`.other_options${response.roleid}_1`).on('click', function (e) {
                                e.stopPropagation();
                                e.preventDefault();
                                if ($(this).find('i').attr('class').indexOf('active') > -1) {
                                    $(this).find('i').removeClass('active').siblings().removeClass('active');
                                } else {
                                    $(document).trigger('click');
                                    $(this).find('i').toggleClass('active').siblings().toggleClass('active');
                                }
                            });
                            $(`.other_options${response.roleid}_1 .report`).on('click', function (e) {
                                e.stopPropagation();
                                e.preventDefault();
                                $(this).removeClass('active');
                                $(`.other_options${response.roleid}_1`).find('i').removeClass('active');
                                checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                if (!window.isLoggedIn) {
                                    login_status()
                                } else {
                                    report_arguments(response.roleid, response.name, response.nsfw);
                                }
                            });
                            $(`.other_options${response.roleid}_1 .character_edit`).on('click', function (e) {
                                e.stopPropagation();
                                e.preventDefault();
                                $(this).removeClass('active');
                                $(`.other_options${response.roleid}_1`).find('i').removeClass('active');
                                checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                if (!window.isLoggedIn) {
                                    login_status()
                                } else {
                                    redirectToUrl($(this).attr('action-href'));
                                }
                            });
                            $(`#robot${response.roleid}_1 .icon-icon_like2`).on('click', function (e) {
                                e.stopPropagation();
                                e.preventDefault();
                                var that = $(this);
                                checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                if (!window.isLoggedIn) {
                                    login_status()
                                } else {
                                    that.toggleClass('active');
                                    var _num = that.attr('like-num');
                                    if (that.hasClass('active')) {
                                        create_like(response.roleid, response.userProfile.uid, 1, _num, that, _creatFlags);
                                    } else {
                                        create_like(response.roleid, response.userProfile.uid, 0, _num, that, _creatFlags);
                                    }
                                }
                            });
                            if ($(`#robot${response.roleid}_1 .profile_card`).length > 0) {
                                $(`#robot${response.roleid}_1 .profile_card`).on('click', function (e) {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    _getAjax(_url.titleList, { uid: response.userProfile.uid ,lang:lang}).then(res => {
                                        if (res.code == 200) {
                                            $('.profileMetalMask').addClass('active');
                                            $('.profileMetal').addClass('active');
                                            $('.profileMetal h2').html(response.userProfile.nickname + i18n[lang].public_Achievement);
                                            $('.profile_metal_list').empty();
                                            $('.profileMetalInfo').remove();
                                            res.data.forEach(item => {
                                                $('.profile_metal_list').append(`
                                          <div class="profile_metal_item" attr-id="${item.id}">
                                              <img src="${item.icon}" alt="Metal" width="100" height="100" />
                                              <p class="title metal_title">${item.title}</p>
                                          </div>
                                          `);
                                                $('.profile_metal_container').after(`
                                          <p class="profileMetalInfo">${item.desc}</p>
                                          `);
                                            });
                                            $('.profile_metal_item').eq(0).addClass('active');
                                            $('.profileMetalInfo').eq(0).addClass('active');
                                            $('#profileMetalBtn').attr('attr-id', $('.profile_metal_item').eq(0).attr('attr-id'));
                                            if (response.userProfile.uid == JSON.parse(cookie.getcookie('userInfoData')).uid) {
                                                $('#profileMetalBtn').hide();
                                            }
                                        } else {
                                            error(i18n[lang].public_Failed_Show_Achievements)
                                        }
                                    });
                                });
                            }
                        });
                        addLoad();
                        setTimeout(() => {
                            page.characters++;
                            isLoading = false;
                            // if(res.data.length>1&&page.characters_total>page.characters_num){shawdow_mask=false};
                            if (res.data.length > 1) { shawdow_mask = false };
                            $('.chatContent #loadBox').hide();
                            //   $('#searchInput').val('');
                            bindScroll();
                            addTooltip();
                        }, 1500)
                    } else {
                        const emptyElement = $(`
                    <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                        <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                        <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                    </div>
                `)
                        $('.chatContent').eq(0).append(emptyElement);
                    }

                })
            }
        } else if ($('.my_card').eq(1).attr('class').indexOf('active') > -1) {
            if ($('.chatContent.active .itemDiv').length < 20) {
                $('.load_more').remove(); return;
            } else {
                if (!shawdow_mask) { $('.main_right .ivu-row.chatContent').eq(1).append(`<div class="load_more"><img src="/images${$theme_path}/sequence/logo_pad.gif" alt="Loading" /></div>`); }
                shawdow_mask = true;
                console.log(page.storys, 'page.storys');
                getAjax(_url.personStoryList, {
                    "uid": cookie.getcookie('uid'),
                    "type": 2,
                    "order": filtrate,
                    "page": page.storys,
                    "nsfw": nsfw
                }).then(res => {
                    $('.main_right .ivu-row.chatContent').eq(1).find('.load_more').remove();
                    if (res.code == 200) {
                        // $('.main_right .ivu-row.chatContent').eq(1).find('.innerContent').eq(0).find('.load_more').remove();
                        // $('.main_right .ivu-row.chatContent').eq(1).find('.innerContent').eq(0).empty();
                        // $('.main_right .ivu-row.chatContent').eq(1).empty();
                        if (res.data.length >= 1) {
                            page.storys_total = res.total;
                            res.data.forEach(response => {
                                var _openid = '', _nickname = '';
                                if (response.userProfile && response.userProfile.openid) {
                                    _openid = response.userProfile.openid
                                }
                                if (response.userProfile && response.userProfile.nickname) {
                                    _nickname = response.userProfile.nickname
                                };
                                page.storys_num++;
                                $('.main_right .ivu-row.chatContent').eq(1).append(`
                            <div class="ivu-col ivu-col-span-xxl-4 chat-story-item itemDiv">
                                <a href="${lang_path}/character/${response.roleid}/story/${response.id}" id="robot446418_1" class="item homeItemInPHP robot446418" data-roleid="446418">
                                    <div class="story-title">${response.title}</div>
                                    <div class="story-name" id="name${response.roleid}" ><span>${i18n[lang].chat_story_Author}</span> <span class="story-user story-user_${response.id}" data-anonymoustype=${response.anonymous_type}  >${response.nickname}</span> </div>
                                    <div class="story-content"> <p>${response.beginning_content}</p> </div>
                                    <div class="story-msg">
                                        <div class="story-msg-item">${i18n[lang].public_Views} <span>${response.views}</span></div>
                                        <div class="story-msg-item">${i18n[lang].public_Likes} <span>${response.likes}</span></div>
                                        <div class="story-msg-item">${i18n[lang].public_Comment} <span>${response.comments_num}</span></div>
                                    </div>
                                </a>
                            </div>`)

                                $(`.itemDiv .story-user_${response.id}`).on('click', function (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    if ($(this).data('anonymoustype') == 1) {
                                        console.log(response.users.openid, 'response.users.openid');
                                        error(i18n[lang].public_story_anonymous)
                                    } else {
                                        redirectToUrl(`${lang_path}/account/profile/${response.users.openid}`);
                                    }
                                });

                            });
                        } else {
                            const emptyElement = $(`
                        <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                            <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                            <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_no_chat_stories}</div>
                        </div>
                    `)
                            if (!$('.chat-story-content .innerContent').eq(1).find('.show_result').length) {
                                $('.chat-story-content .innerContent').eq(1).append(emptyElement);
                            }
                        }
                        addLoad();
                        setTimeout(() => {
                            // story_list_page.characters++;
                            page.storys++;
                            isLoading = false;
                            // if(res.data.length>1&&page.characters_total>page.characters_num){shawdow_mask=false};
                            if (res.data.length > 1) { shawdow_mask = false };
                            $('.chatContent #loadBox').hide();
                            // $('#searchInput').val('');
                            bindScroll();
                        }, 1500)
                    } else {
                        const emptyElement = $(`
                    <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                        <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                        <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_no_chat_stories}</div>
                    </div>
                `)
                        if (!$('.chat-story-content .innerContent').eq(1).find('.show_result').length) {
                            $('.chat-story-content .innerContent').eq(1).append(emptyElement);
                        }
                    }
                    isRequestInProgressStory = false;
                }).catch(err => {
                    isRequestInProgressStory = false;
                });
            }
        } else if ($('.my_card').eq(2).attr('class').indexOf('active') > -1) {
            if ($('.chatContent.active .itemDiv').length < 20) {
                $('.load_more').remove(); return;
            } else {
                if ($('.favorites_select_zoon .style_card').eq(0).attr('class').indexOf('active') > -1) {
                    if (!shawdow_mask) { $('.main_right .ivu-row.chatContent').eq(2).find('.innerContent').eq(0).append(`<div class="load_more"><img src="/images${$theme_path}/sequence/logo_pad.gif" alt="Loading" /></div>`); }
                    shawdow_mask = true;
                    getAjax('/api/getOtherCollectLists', {
                        "uid": getOpenid(),
                        "pageNum": page.favorites,
                        nsfw: nsfw
                    }).then(res => {
                        if (res.code == 200) {
                            $('.load_more').remove();
                            if (res.data.length >= 1) {
                                // if(res.robot_type==0||res.isdel==1){
                                // page.favorites_total=res.total;
                                res.data.forEach(response => {
                                    var _openid = '', _nickname = '';
                                    if (response.userProfile && response.userProfile.openid) {
                                        _openid = response.userProfile.openid
                                    }
                                    if (response.userProfile && response.userProfile.nickname) {
                                        _nickname = response.userProfile.nickname
                                    };
                                    page.favorites_num++;
                                    var _like_num, _chats_num;
                                    response.like_num ? _like_num = autoNumberTransform(response.like_num) : _like_num = 0;
                                    response.chats_num ? _chats_num = autoNumberTransform(response.chats_num) : _chats_num = 0;
                                    $('.main_right .ivu-row.chatContent').eq(2).find('.innerContent').eq(0).append(`
                                <div class="ivu-col ivu-col-span-xxl-4 itemDiv">
                                <a href="/chat/${response.roleid}" id="robot${response.roleid}_4" class="item homeItemInPHP robot${response.roleid}" data-roleid="${response.roleid}"> 
                                            <img src="/images/index/defaultAvatar.svg" class="img default-avatar" 
                                                onerror="this.onerror=null; this.src='/images/index/defaultAvatar.svg';" 
                                                data-avatar="${response.avatar_url}" alt="Character Avatar ${response.name}" width="" height="">
                                                ${response.nsfw == 1 ? `<span class="nsfw">Unfiltered</span>` : response.nsfw == 0 ? `<span class="nsfw sfw">SFW</span>` : ''}
                                        <span audit-src="${lang_path}/character/${response.roleid}" class="name" id="name${response.roleid}">${response.name}</span>
                                        <p class="creator">by <span id="profile${response.roleid}_4" action-href="${lang_path}/account/profile/${_openid}">@${_nickname}</span>${response.userProfile && res.data.uid != response.userProfile.uid && Boolean(response.userProfile.title) ? '<img class="profile_card" src="' + response.userProfile.title_icon + '" alt="Metal" width="24" height="24" title="' + response.userProfile.title + '" attr-title_id="' + response.userProfile.title_id + '"/>' : ''}</p>
                                            <p class="desc${!response.describe || response.describe.length <= 30 ? ' notext' : ''}"
                                            title="${!response.describe || response.describe.length <= 30 ? '' : escapeHtml(response.describe)}">
                                                ${escapeHtml(response.describe) || ''}
                                            </p>
                                            <div class="flex-col-between">
                                                ${response.tagsid && JSON.parse(response.tagsid).length > 0 ? `
                                                    <ul class="tagsBox">
                                                        ${JSON.parse(response.tagsid).map((item, key) => `
                                                            <li class="tagsItem ${TagClass[key % TagClass.length]}">
                                                                ${item.name}
                                                            </li>
                                                        `).join('')}
                                                    </ul>
                                                ` : '<div class="tagsBox"></div>'}
                                                <div class="bottom cen flex_box"> 
                                                    <div class="bottomItem">
                                                        <i class="ivu-icon iconfont svgIcon like icon-icon_like2 ${response.is_like ? 'active' : ''}" like-num="${response.like_num}"></i>
                                                        <span>${_like_num}</span>
                                                    </div> 
                                                    <div class="bottomItem">
                                                        <i class="ivu-icon iconfont icon-size svgIcon chat"></i>
                                                        <span>${_chats_num}</span>
                                                    </div> 
                                                    ${response.more_list[2].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_4"><i class=""></i><span class="report">${i18n[lang].public_Report}</span></div>` : response.more_list[1].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_4"><i class=""></i><span class="character_edit" action-href="${lang_path}/character/edit/${response.roleid}">${i18n[lang].public_Paid}</span></div>` : ''}
                                                </div>
                                            </div>
                                        </a>
                                        </div>`)
                                    const image = new Image();
                                    image.src = response.avatar_url
                                    image.onload = function () {
                                        var $img = $(`#robot${response.roleid}_4`).find('.img');
                                        if ($img.length) {
                                            $img.attr('src', image.src);
                                            var oAbc = $img[0].getBoundingClientRect();
                                            if (oAbc.width) {
                                                $(`#robot${response.roleid}_4 img`).attr({ 'width': oAbc.width, 'height': oAbc.height });
                                            } else {
                                                $(`#robot${response.roleid}_4 img`).attr({ 'width': image.width, 'height': image.height });
                                            }
                                        } else {
                                            console.error('Image element not found for roleid:', response.roleid);
                                        }
                                    };
                                    $(`#name${response.roleid}`).on('click', function (e) {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        redirectToUrl(`${lang_path}/character/${response.roleid}`);
                                    });
                                    $(`#profile${response.roleid}_4`).on('click', function (e) {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        redirectToUrl($(this).attr('action-href'));
                                    });
                                    $(`#robot${response.roleid}_4`).on('click', function (e) {
                                        e.preventDefault();
                                        localStorage.setItem('robotInfo', JSON.stringify({ name: response.name, tags: response.tagsid ? JSON.parse(response.tagsid) : [], greetings: response.greetings }))
                                        redirectToUrl(`/chat/${response.roleid}`)
                                    });
                                    $(`.other_options${response.roleid}_4`).on('click', function (e) {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        if ($(this).find('i').attr('class').indexOf('active') > -1) {
                                            $(this).find('i').removeClass('active').siblings().removeClass('active');
                                        } else {
                                            $(document).trigger('click');
                                            $(this).find('i').toggleClass('active').siblings().toggleClass('active');
                                        }
                                    });
                                    $(`.other_options${response.roleid}_4 .report`).on('click', function (e) {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        $(this).removeClass('active');
                                        $(`.other_options${response.roleid}_4`).find('i').removeClass('active');
                                        checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                        if (!window.isLoggedIn) {
                                            login_status()
                                        } else {
                                            report_arguments(response.roleid, response.name, response.nsfw);
                                        }
                                    });
                                    $(`.other_options${response.roleid}_4 .character_edit`).on('click', function (e) {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        $(this).removeClass('active');
                                        $(`.other_options${response.roleid}_4`).find('i').removeClass('active');
                                        checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                        if (!window.isLoggedIn) {
                                            login_status()
                                        } else {
                                            redirectToUrl($(this).attr('action-href'));
                                        }
                                    });
                                    $(`#robot${response.roleid}_4 .icon-icon_like2`).on('click', function (e) {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        var that = $(this);
                                        checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                        if (!window.isLoggedIn) {
                                            login_status()
                                        } else {
                                            that.toggleClass('active');
                                            var _num = that.attr('like-num');
                                            if (that.hasClass('active')) {
                                                create_like(response.roleid, response.userProfile.uid, 1, _num, that, _creatFlags);
                                            } else {
                                                create_like(response.roleid, response.userProfile.uid, 0, _num, that, _creatFlags);
                                            }
                                        }
                                    });
                                    if ($(`#robot${response.roleid}_4 .profile_card`).length > 0) {
                                        $(`#robot${response.roleid}_4 .profile_card`).on('click', function (e) {
                                            e.stopPropagation();
                                            e.preventDefault();
                                            _getAjax(_url.titleList, { uid: response.userProfile.uid ,lang:lang}).then(res => {
                                                if (res.code == 200) {
                                                    $('.profileMetalMask').addClass('active');
                                                    $('.profileMetal').addClass('active');
                                                    $('.profileMetal h2').html(response.userProfile.nickname + i18n[lang].public_Achievement);
                                                    $('.profile_metal_list').empty();
                                                    $('.profileMetalInfo').remove();
                                                    res.data.forEach(item => {
                                                        $('.profile_metal_list').append(`
                                                    <div class="profile_metal_item" attr-id="${item.id}">
                                                        <img src="${item.icon}" alt="Metal" width="100" height="100" />
                                                        <p class="title metal_title">${item.title}</p>
                                                    </div>
                                                    `);
                                                        $('.profile_metal_container').after(`
                                                    <p class="profileMetalInfo">${item.desc}</p>
                                                    `);
                                                    });
                                                    $('.profile_metal_item').eq(0).addClass('active');
                                                    $('.profileMetalInfo').eq(0).addClass('active');
                                                    $('#profileMetalBtn').attr('attr-id', $('.profile_metal_item').eq(0).attr('attr-id'));
                                                    if (response.userProfile.uid == JSON.parse(cookie.getcookie('userInfoData')).uid) {
                                                        $('#profileMetalBtn').hide();
                                                    }
                                                } else {
                                                    error(i18n[lang].public_Failed_Show_Achievements)
                                                }
                                            });
                                        });
                                    }
                                });
                                // }
                            } else {
                                const emptyElement = $(`
                            <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                                <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                                <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                            </div>
                        `)
                        
                                // $('.chatContent').eq(2).find('.innerContent').eq(0).append(emptyElement);
                            }
                            addLoad();
                            setTimeout(() => {
                                page.favorites++;
                                isLoading = false;
                                // if(res.data.length>1&&page.favorites_total>page.favorites_num){shawdow_mask=false};
                                if (res.data.length > 1) { shawdow_mask = false };
                                $('.chatContent #loadBox').hide();
                                // $('#searchInput').val('');
                                bindScroll();
                                addTooltip();
                            }, 1500)
                        } else if (res.code == 2304) {
                            const emptyElement = $(`
                        <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                            <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                            <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                        </div>
                    `)
                            // $('.chatContent').eq(2).find('.innerContent').eq(0).append(emptyElement);
                        } else {
                            const emptyElement = $(`
                            <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                                <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                                <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                            </div>
                        `)
                            // $('.chatContent').eq(2).find('.innerContent').eq(0).append(emptyElement);
                        }
                    });
                } else if ($('.favorites_select_zoon .style_card').eq(1).attr('class').indexOf('active') > -1) {
                    if (!shawdow_mask) { $('.main_right .ivu-row.chatContent').eq(2).find('.innerContent').eq(1).append(`<div class="load_more"><img src="/images${$theme_path}/sequence/logo_pad.gif" alt="Loading" /></div>`); }
                    shawdow_mask = true;
                         //收藏story翻页渲染
                getAjax(_url.getStoryCollectList, {
                    "uid": cookie.getcookie('uid'),
                    "type": 2,
                    "order": filtrate,
                    "pageNum": page.storys,
                }).then(res => {
                    $('.main_right .ivu-row.chatContent').eq(2).find('.load_more').remove();
                    if (res.code == 200) {
                        $('.main_right .ivu-row.chatContent').eq(2).find('.innerContent').eq(1).find('.load_more').remove();
                        $('.style_card').on('click', function () {
                            $(this).addClass('active').siblings().removeClass('active');
                        });
                        if (res.data.length >= 1) {
                            // page.characters_total=res.total;
                            res.data.forEach(response => {
                                var _openid = '', _nickname = '';
                                if (response.userProfile && response.userProfile.openid) {
                                    _openid = response.userProfile.openid
                                }
                                if (response.userProfile && response.userProfile.nickname) {
                                    _nickname = response.userProfile.nickname
                                };
                                // page.characters_num++;
                                $('.main_right .ivu-row.chatContent').eq(2).find('.innerContent').eq(1).append(`
                                <div class="ivu-col ivu-col-span-xxl-4 chat-story-item itemDiv">
                                    <a href="${lang_path}/character/${response.roleid}/story/${response.id}" id="robot446418_1" class="item homeItemInPHP robot446418" data-roleid="446418">
                                        <div class="story-title">${response.title}</div>
                                        <div class="story-name" id="name${response.roleid}" ><span>${i18n[lang].chat_story_Author}</span> <span class="story-user story-user_${response.id}" data-anonymoustype=${response.anonymous_type}  >${response.nickname}</span> </div>
                                        <div class="story-content"> <p>${response.beginning_content}</p> </div>
                                        <div class="story-msg">
                                            <div class="story-msg-item">${i18n[lang].public_Views} <span>${response.views}</span></div>
                                            <div class="story-msg-item">${i18n[lang].public_Likes} <span>${response.likes}</span></div>
                                            <div class="story-msg-item">${i18n[lang].public_Comment} <span>${response.comments_num}</span></div>
                                        </div>
                                    </a>
                                </div>`)

                                $(`.itemDiv .story-user_${response.id}`).on('click', function (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    if ($(this).data('anonymoustype') == 1) {
                                        console.log(response.users.openid, 'response.users.openid');
                                        error(i18n[lang].public_story_anonymous)
                                    } else {
                                        redirectToUrl(`${lang_path}/account/profile/${response.users.openid}`);
                                    }
                                });

                            });
                        } else {
                          
                        }
                        addLoad();
                        setTimeout(() => {
                            // story_list_page.characters++;
                            isLoading = false;
                            // if(res.data.length>1&&page.characters_total>page.characters_num){shawdow_mask=false};
                            if (res.data.length > 1) { shawdow_mask = false };
                            $('.chatContent #loadBox').hide();
                            // $('#searchInput').val('');
                            bindScroll();
                        }, 1500)
                    } else {
                        const emptyElement = $(`
                        <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                            <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                            <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_no_chat_stories}</div>
                        </div>
                    `)
                        // if (!$('.favorites-content .innerContent').eq(1).find('.show_result').length) {
                        //     $('.favorites-content .innerContent').eq(1).append(emptyElement);
                        // }
                    }
                    isRequestInProgressStory = false;
                })
                }

            }
        } else if ($('.my_card').eq(3).attr('class').indexOf('active') > -1) {
            if ($('.chatContent.active .itemDiv').length < 20) {
                $('.load_more').remove(); return;
            } else {
                if ($('.likes_zoon .style_card').eq(0).attr('class').indexOf('active') > -1) {
                    if (!shawdow_mask) { $('.main_right .ivu-row.chatContent').eq(3).find('.innerContent').eq(0).append(`<div class="load_more"><img src="/images${$theme_path}/sequence/logo_pad.gif" alt="Loading" /></div>`); }
                    shawdow_mask = true;
                    getAjax('/api/getOtherLikesLists', {
                        "uid": getOpenid(),
                        "pageNum": page.likes,
                        nsfw: nsfw
                    }).then(res => {
                        if (res.code == 200) {
                            $('.load_more').remove();
                            if (res.data.length >= 1) {
                                // if(res.robot_type==0||res.isdel==1){
                                // page.likes_total=res.total;
                                res.data.forEach(response => {
                                    var _openid = '', _nickname = '';
                                    if (response.userProfile && response.userProfile.openid) {
                                        _openid = response.userProfile.openid
                                    }
                                    if (response.userProfile && response.userProfile.nickname) {
                                        _nickname = response.userProfile.nickname
                                    };
                                    page.likes_num++;
                                    var _like_num, _chats_num;
                                    response.like_num ? _like_num = autoNumberTransform(response.like_num) : _like_num = 0;
                                    response.chats_num ? _chats_num = autoNumberTransform(response.chats_num) : _chats_num = 0;
                                    $('.main_right .ivu-row.chatContent').eq(3).find('.innerContent').eq(0).append(`
                                <div class="ivu-col ivu-col-span-xxl-4 itemDiv">
                                <a href="/chat/${response.roleid}" id="robot${response.roleid}_5" class="item homeItemInPHP robot${response.roleid}" data-roleid="${response.roleid}"> 
                                            <img src="/images/index/defaultAvatar.svg" class="img default-avatar" 
                                                onerror="this.onerror=null; this.src='/images/index/defaultAvatar.svg';" 
                                                data-avatar="${response.avatar_url}" alt="Character Avatar ${response.name}" width="" height="">
                                                ${response.nsfw == 1 ? `<span class="nsfw">Unfiltered</span>` : response.nsfw == 0 ? `<span class="nsfw sfw">SFW</span>` : ''}
                                        <span audit-src="${lang_path}/character/${response.roleid}" class="name" id="name${response.roleid}">${response.name}</span>
                                        <p class="creator">by <span id="profile${response.roleid}_5" action-href="${lang_path}/account/profile/${_openid}">@${_nickname}</span>${response.userProfile && res.data.uid != response.userProfile.uid && Boolean(response.userProfile.title) ? '<img class="profile_card" src="' + response.userProfile.title_icon + '" alt="Metal" width="24" height="24" title="' + response.userProfile.title + '" attr-title_id="' + response.userProfile.title_id + '"/>' : ''}</p>
                                            <p class="desc${!response.describe || response.describe.length <= 30 ? ' notext' : ''}"
                                            title="${!response.describe || response.describe.length <= 30 ? '' : escapeHtml(response.describe)}">
                                                ${escapeHtml(response.describe) || ''}
                                            </p>
                                            <div class="flex-col-between">
                                                ${response.tagsid && JSON.parse(response.tagsid).length > 0 ? `
                                                    <ul class="tagsBox">
                                                        ${JSON.parse(response.tagsid).map((item, key) => `
                                                            <li class="tagsItem ${TagClass[key % TagClass.length]}">
                                                                ${item.name}
                                                            </li>
                                                        `).join('')}
                                                    </ul>
                                                ` : '<div class="tagsBox"></div>'}
                                                <div class="bottom cen flex_box"> 
                                                    <div class="bottomItem">
                                                        <i class="ivu-icon iconfont svgIcon like icon-icon_like2 ${response.is_like ? 'active' : ''}" like-num="${response.like_num}"></i>
                                                        <span>${_like_num}</span>
                                                    </div> 
                                                    <div class="bottomItem">
                                                        <i class="ivu-icon iconfont icon-size svgIcon chat"></i>
                                                        <span>${_chats_num}</span>
                                                    </div> 
                                                    ${response.more_list[2].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_5"><i class=""></i><span class="report">${i18n[lang].public_Report}</span></div>` : response.more_list[1].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_5"><i class=""></i><span class="character_edit" action-href="${lang_path}/character/edit/${response.roleid}">${i18n[lang].public_Paid}</span></div>` : ''}
                                                </div>
                                            </div>
                                        </a>
                                        </div>`)
                                    const image = new Image();
                                    image.src = response.avatar_url
                                    image.onload = function () {
                                        var $img = $(`#robot${response.roleid}_5`).find('.img');
                                        if ($img.length) {
                                            $img.attr('src', image.src);
                                            var oAbc = $img[0].getBoundingClientRect();
                                            if (oAbc.width) {
                                                $(`#robot${response.roleid}_5 img`).attr({ 'width': oAbc.width, 'height': oAbc.height });
                                            } else {
                                                $(`#robot${response.roleid}_5 img`).attr({ 'width': image.width, 'height': image.height });
                                            }
                                        } else {
                                            console.error('Image element not found for roleid:', response.roleid);
                                        }
                                    };
                                    $(`#name${response.roleid}`).on('click', function (e) {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        redirectToUrl(`${lang_path}/character/${response.roleid}`);
                                    });
                                    $(`#profile${response.roleid}_5`).on('click', function (e) {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        redirectToUrl($(this).attr('action-href'));
                                    });
                                    $(`#robot${response.roleid}_5`).on('click', function (e) {
                                        e.preventDefault();
                                        localStorage.setItem('robotInfo', JSON.stringify({ name: response.name, tags: response.tagsid ? JSON.parse(response.tagsid) : [], greetings: response.greetings }))
                                        redirectToUrl(`/chat/${response.roleid}`)
                                    });
                                    $(`.other_options${response.roleid}_5`).on('click', function (e) {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        if ($(this).find('i').attr('class').indexOf('active') > -1) {
                                            $(this).find('i').removeClass('active').siblings().removeClass('active');
                                        } else {
                                            $(document).trigger('click');
                                            $(this).find('i').toggleClass('active').siblings().toggleClass('active');
                                        }
                                    });
                                    $(`.other_options${response.roleid}_5 .report`).on('click', function (e) {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        $(this).removeClass('active');
                                        $(`.other_options${response.roleid}_5`).find('i').removeClass('active');
                                        checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                        if (!window.isLoggedIn) {
                                            login_status()
                                        } else {
                                            report_arguments(response.roleid, response.name, response.nsfw);
                                        }
                                    });
                                    $(`.other_options${response.roleid}_5 .character_edit`).on('click', function (e) {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        $(this).removeClass('active');
                                        $(`.other_options${response.roleid}_5`).find('i').removeClass('active');
                                        checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                        if (!window.isLoggedIn) {
                                            login_status()
                                        } else {
                                            redirectToUrl($(this).attr('action-href'));
                                        }
                                    });
                                    $(`#robot${response.roleid}_5 .icon-icon_like2`).on('click', function (e) {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        var that = $(this);
                                        checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                        if (!window.isLoggedIn) {
                                            login_status()
                                        } else {
                                            that.toggleClass('active');
                                            var _num = that.attr('like-num');
                                            if (that.hasClass('active')) {
                                                create_like(response.roleid, response.userProfile.uid, 1, _num, that, _creatFlags);
                                            } else {
                                                create_like(response.roleid, response.userProfile.uid, 0, _num, that, _creatFlags);
                                            }
                                        }
                                    });
                                    if ($(`#robot${response.roleid}_5 .profile_card`).length > 0) {
                                        $(`#robot${response.roleid}_5 .profile_card`).on('click', function (e) {
                                            e.stopPropagation();
                                            e.preventDefault();
                                            _getAjax(_url.titleList, { uid: response.userProfile.uid ,lang:lang}).then(res => {
                                                if (res.code == 200) {
                                                    $('.profileMetalMask').addClass('active');
                                                    $('.profileMetal').addClass('active');
                                                    $('.profileMetal h2').html(response.userProfile.nickname + i18n[lang].public_Achievement);
                                                    $('.profile_metal_list').empty();
                                                    $('.profileMetalInfo').remove();
                                                    res.data.forEach(item => {
                                                        $('.profile_metal_list').append(`
                                                    <div class="profile_metal_item" attr-id="${item.id}">
                                                        <img src="${item.icon}" alt="Metal" width="100" height="100" />
                                                        <p class="title metal_title">${item.title}</p>
                                                    </div>
                                                    `);
                                                        $('.profile_metal_container').after(`
                                                    <p class="profileMetalInfo">${item.desc}</p>
                                                    `);
                                                    });
                                                    $('.profile_metal_item').eq(0).addClass('active');
                                                    $('.profileMetalInfo').eq(0).addClass('active');
                                                    $('#profileMetalBtn').attr('attr-id', $('.profile_metal_item').eq(0).attr('attr-id'));
                                                    if (response.userProfile.uid == JSON.parse(cookie.getcookie('userInfoData')).uid) {
                                                        $('#profileMetalBtn').hide();
                                                    }
                                                } else {
                                                    error(i18n[lang].public_Failed_Show_Achievements)
                                                }
                                            });
                                        });
                                    }
                                });
                                // }
                            } else {
                                const emptyElement = $(`
                            <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                                <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                                <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                            </div>
                        `)
                                // $('.chatContent').eq(3).find('.innerContent').eq(0).append(emptyElement);
                            }
                            addLoad();
                            setTimeout(() => {
                                page.likes++;
                                isLoading = false;
                                // if(res.data.length>1&&page.likes_total>page.likes_num){shawdow_mask=false};
                                if (res.data.length > 1) { shawdow_mask = false };
                                $('.chatContent #loadBox').hide();
                                // $('#searchInput').val('');
                                bindScroll();
                                addTooltip();
                            }, 1500)
                        } else if (res.code == 2304) {
                            const emptyElement = $(`
                        <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                            <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                            <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                        </div>
                    `)
                            // $('.chatContent').eq(3).find('.innerContent').eq(0).append(emptyElement);
                        } else {
                            const emptyElement = $(`
                        <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                            <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                            <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                        </div>
                    `)
                            // $('.chatContent').eq(3).find('.innerContent').eq(0).append(emptyElement);
                        }
                    })
                } else if ($('.likes_zoon .style_card').eq(1).attr('class').indexOf('active') > -1) {
                    if (!shawdow_mask) { $('.main_right .ivu-row.chatContent').eq(2).find('.innerContent').eq(1).append(`<div class="load_more"><img src="/images${$theme_path}/sequence/logo_pad.gif" alt="Loading" /></div>`); }
                    shawdow_mask = true;
                         //收藏story翻页渲染
                getAjax(_url.likeStoryList, {
                    "uid": cookie.getcookie('uid'),
                    "type": 2,
                    "order": filtrate,
                    "page": page.storys,
                }).then(res => {
                    $('.main_right .ivu-row.chatContent').eq(2).find('.load_more').remove();
                    if (res.code == 200) {
                        $('.main_right .ivu-row.chatContent').eq(2).find('.innerContent').eq(1).find('.load_more').remove();
                        $('.style_card').on('click', function () {
                            $(this).addClass('active').siblings().removeClass('active');
                        });
                        if (res.data.length >= 1) {
                            // page.characters_total=res.total;
                            res.data.forEach(response => {
                                var _openid = '', _nickname = '';
                                if (response.userProfile && response.userProfile.openid) {
                                    _openid = response.userProfile.openid
                                }
                                if (response.userProfile && response.userProfile.nickname) {
                                    _nickname = response.userProfile.nickname
                                };
                                // page.characters_num++;
                                $('.main_right .ivu-row.chatContent').eq(3).find('.innerContent').eq(1).append(`
                                <div class="ivu-col ivu-col-span-xxl-4 chat-story-item itemDiv">
                                    <a href="${lang_path}/character/${response.roleid}/story/${response.id}" id="robot446418_1" class="item homeItemInPHP robot446418" data-roleid="446418">
                                        <div class="story-title">${response.title}</div>
                                        <div class="story-name" id="name${response.roleid}" ><span>${i18n[lang].chat_story_Author}</span> <span class="story-user story-user_${response.id}" data-anonymoustype=${response.anonymous_type}  >${response.nickname}</span> </div>
                                        <div class="story-content"> <p>${response.beginning_content}</p> </div>
                                        <div class="story-msg">
                                            <div class="story-msg-item">${i18n[lang].public_Views} <span>${response.views}</span></div>
                                            <div class="story-msg-item">${i18n[lang].public_Likes} <span>${response.likes}</span></div>
                                            <div class="story-msg-item">${i18n[lang].public_Comment} <span>${response.comments_num}</span></div>
                                        </div>
                                    </a>
                                </div>`)

                                $(`.itemDiv .story-user_${response.id}`).on('click', function (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    if ($(this).data('anonymoustype') == 1) {
                                        console.log(response.users.openid, 'response.users.openid');
                                        error(i18n[lang].public_story_anonymous)
                                    } else {
                                        redirectToUrl(`${lang_path}/account/profile/${response.users.openid}`);
                                    }
                                });

                            });
                        } else {
                          
                        }
                        addLoad();
                        setTimeout(() => {
                            // story_list_page.characters++;
                            isLoading = false;
                            // if(res.data.length>1&&page.characters_total>page.characters_num){shawdow_mask=false};
                            if (res.data.length > 1) { shawdow_mask = false };
                            $('.chatContent #loadBox').hide();
                            // $('#searchInput').val('');
                            bindScroll();
                        }, 1500)
                    } else {
                        const emptyElement = $(`
                        <div style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto;width: 100%;">
                            <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                            <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_no_chat_stories}</div>
                        </div>
                    `)
                        // if (!$('.favorites-content .innerContent').eq(1).find('.show_result').length) {
                        //     $('.favorites-content .innerContent').eq(1).append(emptyElement);
                        // }
                    }
                    isRequestInProgressStory = false;
                })
                }
              
            }
        }
    }

    getAjax(_url.getNsfw).then(res => {
        if (res.code === 200) {
            const swValue = cookie.getcookie('sw');
            // if (swValue == '1' || swValue==null ) {
            if (swValue == '1') {
                switchBoxtrue();
                nsfw = 1;
            } else if (swValue == '0') {
                switchBoxfalse();
                nsfw = 0;
            } else {
                // 如果cookie中没有设置sw值，则根据res.data.status的值来处理
                if (res.data.status == 1) {
                    switchBoxtrue();
                    nsfw = 1;
                } else {
                    switchBoxfalse();
                    nsfw = 0;
                }
            }
        }
    });
    $('.character_select_zoon .genderAllTransparentMask,.story_select_zoon .genderAllTransparentMask').on('click', function (e) {
        e.stopPropagation();
        $('.character_select_zoon .genderAllTransparentMask').removeClass('active').hide();
        $('.story_select_zoon .genderAllTransparentMask').removeClass('active').hide();
        $('html').removeClass('hide');
    });
    // $('.story_select_zoon .genderAllTransparentMask').on('click', function (e) {
    //     e.stopPropagation();
    //     $('.story_select_zoon .genderAllTransparentMask').removeClass('active').hide();
    //     $('html').removeClass('hide');
    // });

    if ($('.character_select_zoon .genderAllTransparentMask .recentListContent .item').length > 0) {
        $('.character_select_zoon .genderAllTransparentMask .recentListContent .item').each((i, el) => {
            $(el).on('click', function (e) {
                e.stopPropagation();
                e.preventDefault();
                if (_isRequestInProgress) {
                    warning(i18n[lang].pricing_character_finish_loading)
                    return
                };
                _first_check = true;
                e.stopPropagation();
                switch ($(this).index()) {
                    case 0:
                        filtrate = 3;
                        manage('Profile_Latest_Click', '');
                        break;
                    case 1:
                        filtrate = 1;
                        manage('Profile_Popular_Click', '');
                        break;
                };
                var profile_filtrate = {
                    filtrate: filtrate,
                    openid: cookie.getcookie('userInfoData') ? JSON.parse(cookie.getcookie('userInfoData')).openid : null,
                }
                cookie.setcookie('profile_filtrate', JSON.stringify(profile_filtrate));
                $('.character_select_zoon .classification .genderAll i').eq(0).html($(el).text());
                $('.character_select_zoon .genderAllTransparentMask').removeClass('active').hide();
                _first_check = true;
                add_type_lists(nsfw, filtrate, robot_type);


                $('html').removeClass('hide');
            });
        });
        $('.recentListContent').on('click', function () {
            return false;
        })
    };
    //故事下拉框展开
    $('.story_select_zoon .genderAll').click(function () {
        var $genderAll = $('.story_select_zoon #showGender');
        if ($genderAll.css('display') === 'none') {
            $genderAll.show();
            if ($(window).width() > 650) {
                $('.story_select_zoon .recentListContent').css({
                    'top': $('.story_select_zoon .classification .genderAll').offset().top + 55 - $(window).scrollTop(),
                    'left': $('.story_select_zoon .classification .genderAll').offset().left - 8
                });
            } else {
                $('.story_select_zoon .recentListContent').css({
                    'top': $('.story_select_zoon .classification .genderAll').offset().top + 35 - $(window).scrollTop(),
                    'left': $('.story_select_zoon .classification .genderAll').offset().left - 8
                });
            }
            $('.story_select_zoon .genderAllTransparentMask').addClass('active');
            $(this).addClass('active');
            $('html').addClass('hide');
        }
    })
    if ($('.story_select_zoon .genderAllTransparentMask .recentListContent .item').length > 0) {
        $('.story_select_zoon .genderAllTransparentMask .recentListContent .item').each((i, el) => {
            $(el).on('click', function (e) {
                e.stopPropagation();
                e.preventDefault();
                if (_isRequestInProgress) {
                    warning(i18n[lang].pricing_character_finish_loading)
                    return
                };
                _first_check = true;
                e.stopPropagation();
                switch ($(this).index()) {
                    case 0:
                        filtrate = 3;
                        // manage('Profile_Latest_Click', '');
                        break;
                    case 1:
                        filtrate = 1;
                        // manage('Profile_Popular_Click', '');
                        break;
                };
                // var profile_filtrate = {
                //     filtrate: filtrate,
                //     openid: cookie.getcookie('userInfoData') ? JSON.parse(cookie.getcookie('userInfoData')).openid : null,
                // }
                // cookie.setcookie('profile_filtrate', JSON.stringify(profile_filtrate));
                $('.story_select_zoon .classification .genderAll i').eq(0).html($(el).text());
                $('.story_select_zoon .genderAllTransparentMask').removeClass('active').hide();
                _first_check = true;
                page.storys=1;
                add_type_story_lists(nsfw, filtrate, robot_type);
                $('html').removeClass('hide');
            });
        });
        $('.recentListContent').on('click', function () {
            return false;
        })
    };
    $('.likes-content .style_card').on('click', function () {

        $(this).addClass('active').siblings().removeClass('active');
        $('.likes-content .innerContent').eq($(this).index()).addClass('active').siblings().removeClass('active');
        setStatus();
    });
    $('.favorites-content .style_card').on('click', function () {

        $(this).addClass('active').siblings().removeClass('active');
        $('.favorites-content .innerContent').eq($(this).index()).addClass('active').siblings().removeClass('active');
        setStatus();
    });
    $('.switchBoxfalse span').click(async function () {
        if (loadSwitchBox || _isRequestInProgress) {
            warning(i18n[lang].pricing_character_finish_loading)
            return;
        }
        _first_check = true;
        switchBoxtrue();
        nsfw = 1;
        cookie.setcookie('sw', 1);
        loadSwitchBox = true;
        try {
            // 检查最近的类名为 'select_zoon' 的父辈元素，是否还包含类名 'character_select_zoon'
            var hasClass = $(this).closest('.select_zoon').hasClass('character_select_zoon');

            // 根据结果进行操作
            if (hasClass) {
                await add_type_lists(nsfw, filtrate);
            } else {
                await add_type_story_lists(nsfw, filtrate);
            }


        } finally {
            setTimeout(() => {
                loadSwitchBox = false;
            }, 1000)
        }
        // manage('NSFW_Button_Click', 'open');
    });
    $('.switchBoxtrue span').click(async function (e) {
        if (loadSwitchBox || _isRequestInProgress) {
            warning(i18n[lang].pricing_character_finish_loading)
            return;
        }
        e.stopPropagation();
        _first_check = true;
        switchBoxfalse();
        nsfw = 0;
        cookie.setcookie('sw', 0);
        loadSwitchBox = true;
        try {
            // 检查最近的类名为 'select_zoon' 的父辈元素，是否还包含类名 'character_select_zoon'
            var hasClass = $(this).closest('.select_zoon').hasClass('character_select_zoon');

            // 根据结果进行操作
            if (hasClass) {
                await add_type_lists(nsfw, filtrate);
            } else {
                await add_type_story_lists(nsfw, filtrate);
            }
        } finally {
            setTimeout(() => {
                loadSwitchBox = false;
            }, 1000)
        }
        // manage('NSFW_Button_Click', 'close');
    });
    // 修改函数的进位
    function autoNumberTransform(num) {
        var like_num = num;
        if (like_num < 1000) {
            like_num = like_num;
        }
        else if (like_num >= 1000 && like_num < 1000000) {
            like_num = (like_num / 1000).toFixed(1) + 'K';
        }
        else if (like_num >= 1000000 && like_num < 1000000000) {
            like_num = (like_num / 1000000).toFixed(1) + 'M';
        }
        else if (like_num >= 1000000000) {
            like_num = (like_num / 1000000).toFixed(1) + 'B';
        }
        return like_num;
    };
    async function add_type_lists(nsfw, filtrate, robot_type) {
        if (_isRequestInProgress) {
            return;
        };
        _isRequestInProgress = true;
        if (_first_check) {
            $('.main_right .ivu-row.chatContent').eq(0).empty();
            $('.main_right .ivu-row.chatContent').eq(0).append(`<div class="load_more big"><img src="/images${$theme_path}/sequence/logo_pad.gif" alt="Loading" /></div>`);
            page.characters = 1;
            per_page = page.characters;
            page.characters_num = 0;
            //第一个盒子渲染
            getAjax(`/api/getOtherRobotsLists`, {
                uid: getOpenid(),
                filtrate: filtrate,
                pageNum: page.characters,
                robot_type: robot_type,
                nsfw: nsfw
            }).then(res => {
                if (res.code == 200) {
                    $('.main_right .ivu-row.chatContent').eq(0).find('.load_more').remove();
                    page.characters_total = res.total;
                    if (res.data.length >= 1) {
                        res.data.forEach(response => {
                            var _openid = '', _nickname = '';
                            if (response.userProfile && response.userProfile.openid) {
                                _openid = response.userProfile.openid
                            }
                            if (response.userProfile && response.userProfile.nickname) {
                                _nickname = response.userProfile.nickname
                            };
                            page.characters_num++;
                            var _like_num, _chats_num;
                            response.like_num ? _like_num = autoNumberTransform(response.like_num) : _like_num = 0;
                            response.chats_num ? _chats_num = autoNumberTransform(response.chats_num) : _chats_num = 0;
                            $('.main_right .ivu-row.chatContent').eq(0).append(`
                            <div class="ivu-col ivu-col-span-xxl-4 itemDiv">
                                    <a href="/chat/${response.roleid}" id="robot${response.roleid}_1" class="item homeItemInPHP robot${response.roleid}_1" data-roleid="${response.roleid}">
                                    <div class="character-img-box">
                                        <img src="/images/index/defaultAvatar.svg" class="img default-avatar" 
                                            onerror="this.onerror=null; this.src='/images/index/defaultAvatar.svg';" 
                                            data-avatar="${response.avatar_url}" alt="Character Avatar ${response.name}" width="" height="">
                                            ${response.ex_status == 2 ? `<span class="character-status private"><i></i>${i18n[lang].public_Private}</span>` : response.ex_status == 3 ? `<span class="character-status restricted"><i></i>${i18n[lang].public_Restricted_Display}</span>` : response.ex_status == 0 ? `<span class="character-status"><i></i>${i18n[lang].public_Under_Review}</span>` : ''}
                                    
                                                </div> 
                                    ${response.nsfw == 1 ? `<span class="nsfw">Unfiltered</span>` : response.nsfw == 0 ? `<span class="nsfw sfw">SFW</span>` : ''}
                                    <span audit-src="${lang_path}/character/${response.roleid}" class="name" id="name${response.roleid}_1">${response.name}</span>
                                    <p class="creator">by <span id="profile${response.roleid}_1" action-href="${lang_path}/account/profile/${_openid}">@${_nickname}</span></p>
                                        <div class="desc${!response.describe || response.describe.length <= 30 ? ' notext' : ''}" title="${!response.describe || response.describe.length <= 30 ? '' : escapeHtml(response.describe)}">
                                            ${escapeHtml(response.describe) || ''}
                                        </div>
                                        <div class="flex-col-between">
                                            ${response.tagsid && JSON.parse(response.tagsid).length > 0 ? `
                                                <ul class="tagsBox">
                                                    ${JSON.parse(response.tagsid).map((item, key) => `
                                                        <li class="tagsItem ${TagClass[key % TagClass.length]}">
                                                            ${item.name}
                                                        </li>
                                                    `).join('')}
                                                </ul>
                                            ` : '<div class="tagsBox"></div>'}
                                            <div class="bottom cen flex_box"> 
                                                <div class="bottomItem">
                                                    <i class="ivu-icon iconfont svgIcon like icon-icon_like2 ${response.is_like ? 'active' : ''}" like-num="${response.like_num}"></i>
                                                    <span>${_like_num}</span>
                                                </div> 
                                                <div class="bottomItem">
                                                    <i class="ivu-icon iconfont icon-size svgIcon chat"></i>
                                                    <span>${_chats_num}</span>
                                                </div> 
                                                ${response.more_list[2].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_1"><i class=""></i><span class="report">${i18n[lang].public_Report}</span></div>` : response.more_list[1].status == 1 ? `<div id="other_options${response.roleid}" class="other_options other_options${response.roleid}_1"><i class=""></i><span class="character_edit" action-href="${lang_path}/character/edit/${response.roleid}">${i18n[lang].public_Paid}</span></div>` : ''}
                                            </div>
                                        </div>
                                    </a>
                                </div>`);
                            const image = new Image();
                            image.src = response.avatar_url
                            image.onload = function () {
                                var $img = $(`#robot${response.roleid}_1`).find('.img');
                                if ($img.length) {
                                    $img.attr('src', image.src);
                                    var oAbc = $img[0].getBoundingClientRect();
                                    if (oAbc.width) {
                                        $img.attr({ 'width': oAbc.width, 'height': oAbc.height });
                                    } else {
                                        $img.attr({ 'width': image.width, 'height': image.height });
                                    }
                                } else {
                                    console.error('Image element not found for roleid:', response.roleid);
                                }
                            }
                            $(`#name${response.roleid}_1`).on('click', function (e) {
                                e.preventDefault();
                                e.stopPropagation();
                                redirectToUrl(`${lang_path}/character/${response.roleid}`);
                            });
                            $(`.other_options${response.roleid}_1`).on('click', function (e) {
                                e.stopPropagation();
                                e.preventDefault();
                                if ($(this).find('i').attr('class').indexOf('active') > -1) {
                                    $(this).find('i').removeClass('active').siblings().removeClass('active');
                                } else {
                                    $(document).trigger('click');
                                    $(this).find('i').toggleClass('active').siblings().toggleClass('active');
                                }
                            });
                            $(`.other_options${response.roleid}_1 .report`).on('click', function (e) {
                                e.stopPropagation();
                                e.preventDefault();
                                $(this).removeClass('active');
                                $(`.other_options${response.roleid}_1`).find('i').removeClass('active');
                                checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                if (!window.isLoggedIn) {
                                    login_status()
                                } else {
                                    report_arguments(response.roleid, response.name, response.nsfw);
                                }
                            });
                            $(`.other_options${response.roleid}_1 .character_edit`).on('click', function (e) {
                                e.stopPropagation();
                                e.preventDefault();
                                $(this).removeClass('active');
                                $(`.other_options${response.roleid}_1`).find('i').removeClass('active');
                                checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                if (!window.isLoggedIn) {
                                    login_status()
                                } else {
                                    redirectToUrl($(this).attr('action-href'));
                                }
                            });
                            $(`#robot${response.roleid}_1 .icon-icon_like2`).on('click', function (e) {
                                e.stopPropagation();
                                e.preventDefault();
                                var that = $(this);
                                checkLoginStatus(); // 每次点击按钮时先检查登录状态
                                if (!window.isLoggedIn) {
                                    login_status()
                                } else {
                                    that.toggleClass('active');
                                    var _num = that.attr('like-num');
                                    if (that.hasClass('active')) {
                                        create_like(response.roleid, response.userProfile.uid, 1, _num, that, _creatFlags);
                                    } else {
                                        create_like(response.roleid, response.userProfile.uid, 0, _num, that, _creatFlags);
                                    }
                                }
                            });
                        });
                    } else {
                        const emptyElement = $(`
                                        <div class="show_result" style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto; width:100%;">
                                            <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                                            <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                                        </div>
                                    `)
                        if (!$('.innerContent').eq(0).find('.show_result').length) {
                            $('.innerContent').eq(0).append(emptyElement);
                        }
                    }
                    addLoad();
                    setTimeout(() => {
                        page.characters++;
                        isLoading = false;
                        if (res.data.length > 1 && page.characters_total > page.characters_num) { mask_shawdow = false };
                        $('.chatContent #loadBox').hide();
                        $('#searchInput').val('');
                        addTooltip();
                        bindScroll();
                    }, 1500)

                };
                _isRequestInProgress = false;
            }).catch(error => {
                console.error('Error fetching robot list:', error);
                _isRequestInProgress = false; // 确保在请求失败时重置标志变量
            })

            _first_check = false;
        };
    };
    async function add_type_story_lists(nsfw, filtrate, robot_type) {
        if (_isRequestInProgress) {
            return;
        };
        _isRequestInProgress = true;
        if (_first_check) {
            $('.main_right .ivu-row.chatContent').eq(1).empty();
            $('.main_right .ivu-row.chatContent').eq(1).append(`<div class="load_more big"><img src="/images${$theme_path}/sequence/logo_pad.gif" alt="Loading" /></div>`);
            page.storys = 1;
            per_page = page.storys;
            page.storys_num = 0;
            //第一个盒子渲染
            getAjax(_url.personStoryList, {
                "uid": cookie.getcookie('uid'),
                "type": 2,
                "order": filtrate,
                "nsfw": nsfw,
                "page": page.storys,
            }).then(res => {
                if (res.code == 200) {
                    $('.main_right .ivu-row.chatContent').eq(1).find('.load_more').remove();
                    page.storys_total = res.total;
                    if (res.data.length >= 1) {
                        res.data.forEach(response => {
                            var _openid = '', _nickname = '';
                            if (response.userProfile && response.userProfile.openid) {
                                _openid = response.userProfile.openid
                            }
                            if (response.userProfile && response.userProfile.nickname) {
                                _nickname = response.userProfile.nickname
                            };
                            page.storys_num++;
                            console.log(page.storys_num, 'page.storys_num');
                            // var _like_num, _chats_num;
                            // response.like_num ? _like_num = autoNumberTransform(response.like_num) : _like_num = 0;
                            // response.chats_num ? _chats_num = autoNumberTransform(response.chats_num) : _chats_num = 0;
                            $('.main_right .ivu-row.chatContent').eq(1).append(`
                                <div class="ivu-col ivu-col-span-xxl-4 chat-story-item itemDiv">
                                        <a href="${lang_path}/character/${response.roleid}/story/${response.id}" id="robot446418_1" class="item homeItemInPHP robot446418" data-roleid="446418">
                                            <div class="story-title">${response.title}</div>
                                            <div class="story-name" id="name${response.roleid}" ><span>${i18n[lang].chat_story_Author}</span> <span class="story-user story-user_${response.id}" data-anonymoustype=${response.anonymous_type}  >${response.nickname}</span> </div>
                                            <div class="story-content"> <p>${response.beginning_content}</p> </div>
                                            <div class="story-msg">
                                                <div class="story-msg-item">${i18n[lang].public_Views} <span>${response.views}</span></div>
                                                <div class="story-msg-item">${i18n[lang].public_Likes} <span>${response.likes}</span></div>
                                                <div class="story-msg-item">${i18n[lang].public_Comment} <span>${response.comments_num}</span></div>
                                            </div>
                                        </a>
                                    </div>`)
                            $(`.itemDiv .story-user_${response.id}`).on('click', function (e) {
                                e.preventDefault();
                                e.stopPropagation();
                                if ($(this).data('anonymoustype') == 1) {
                                    console.log(response.users.openid, 'response.users.openid');
                                    error(i18n[lang].public_story_anonymous)
                                } else {
                                    redirectToUrl(`${lang_path}/account/profile/${response.users.openid}`);
                                }
                            });
                        });
                    } else {
                        const emptyElement = $(`
                                        <div class="show_result" style="display: flex; flex-direction: column; align-items: center; margin: 12.5rem auto; width:100%;">
                                            <img src="/images${$theme_path}/index/no_result.svg" width="110" height="110" style="width: 6.875rem; height: 6.875rem;"/>
                                            <div style="font-size: 1.125rem; font-weight: bold; color: #555555;">${i18n[lang].public_results_not_found}</div>
                                        </div>
                                    `)
                        if (!$('.innerContent').eq(1).find('.show_result').length) {
                            $('.innerContent').eq(1).append(emptyElement);
                        }
                    }
                    addLoad();
                    setTimeout(() => {
                        page.storys++;
                        isLoading = false;
                        if (res.data.length > 1 && page.storys_total > page.storys_num) { mask_shawdow = false };
                        $('.chatContent #loadBox').hide();
                        $('#searchInput').val('');
                        addTooltip();
                        bindScroll();
                    }, 1500)

                };
                _isRequestInProgress = false;
            }).catch(error => {
                console.error('Error fetching robot list:', error);
                _isRequestInProgress = false; // 确保在请求失败时重置标志变量
            })

            _first_check = false;
        };
    };
    // 解除绑定 scroll 事件
    function unbindScroll() {
        $(window).off('scroll', handleScroll);
    }

    // 重新绑定 scroll 事件
    function bindScroll() {
        $(window).on('scroll', handleScroll);
    }

    // 定义 scroll 事件处理函数
    function handleScroll() {
        const scrollTop = $(this).scrollTop();
        const scrollHeight = $('#main_right').height();
        const clientHeight = $(this).height();
        if (scrollTop + clientHeight >= scrollHeight - 320) {

            loadMore();
        }
    }
    bindScroll();
});
function setStatus() {
    for (var ok = 0; ok < $('.homeItemInPHP .default-avatar').length; ok++) {
        var oAbc = $('.homeItemInPHP .default-avatar').eq(ok)[0].getBoundingClientRect();
        $('.homeItemInPHP .default-avatar').eq(ok).attr({ 'width': oAbc.width, 'height': oAbc.height })
    }
};
setStatus();

//获取按钮状态
setTimeout(function () {
    getAjax(_url.getUserReportLabel, {lang:lang}).then(res => {
        if (res.code == 200) {
            for (var i = 0; i < res.data.length; i++) {
                $('#profile_report_form .title').before(`<label for="profile_report_${res.data[i].id}"><input id="profile_report_${res.data[i].id}" type="checkbox" name="profile_report" />${res.data[i].name}</label>`);
            };
        } else {
            error(i18n[lang].public_Something_wrong);
        }
    });
}, 3000);
$('#profile_report_form').on('submit', function (e) {
    // 阻止表单默认提交行为
    e.preventDefault();
    $('#profile_report_btn').html('<img src="/images/account/loading.svg" alt="Loading">');
    var _flag = true;
    // 点击提交按钮，获取所选的报表id
    var reportIdsl = [], reportIds = '';
    for (var i = 0; i < $('input[name="profile_report"]:checked').length; i++) {
        reportIdsl.push($('input[name="profile_report"]:checked').eq(i).attr('id').replace('profile_report_', ''));
    };
    if (reportIdsl.length == 1) {
        reportIds = reportIdsl[0]
    } else if (reportIdsl.length > 1) {
        reportIds = reportIdsl.join(',')
    };
    detail_describe = $('#profile_report_info').val();
    // 执行报表提交操作
    if (reportIdsl.length == 0) {
        _flag = false;
        if (!$('.info_tip').length) {
            $('#profile_report_select_title').after(`<p class="info info_tip"></p>`);
        };
        $('.info_tip').html(i18n[lang].public_select_reason);
        $('.info_tip').css('top', document.getElementById('profile_report_select_title').offsetTop + $('#profile_report_select_title').height() - 2);
        //查看提示文字是多少行
        var num = Math.round($('.info_tip').height() / parseFloat($('.info_tip').css('line-height')))
        if (num > 1 && $(window).width() > 560) {
            $('#select_title').css({
                marginBottom: $('.info_tip').height() + $('#select_title').height()
            })
        };
        $('#profile_report_btn').html(i18n[lang].public_Submit);
    } else {
        $('.info_tip').remove();
    };
    if (_flag) {
        getAjax(_url.addUserReport, {
            "report_uid": report_uid,
            "reportIds": reportIds,
            "detail_describe": detail_describe,
        }).then(res => {
            $('#profile_report_btn').html(i18n[lang].public_Submit);
            $('.profile_report_zoon').removeClass('active');
            $('.profile_report').removeClass('active');
            $('#profile_report_info').val('');
            $('#profile_report').removeClass('active');
            $('#profile_report_num').html('0');
            $('.profile_report_zoon input').prop('checked', false);
            $('.info_tip').remove();
            if (res.code == 200) {
                profile_report_toast('success', i18n[lang].public_Successful_report1, i18n[lang].public_Successful_report);
            } else if (res.code == 2017 || res.code == '2017') {
                profile_report_toast('error', i18n[lang].public_Reported_too_often1, i18n[lang].public_Reported_too_often);
            } else if (res.code == 2016 || res.code == '2016') {
                profile_report_toast('error', i18n[lang].public_Failed_report, i18n[lang].public_length_characters_1000);
            } else {
                error(i18n[lang].public_Network_error)
            }
        });
    }
});
$('.profile_report_zoon .profile_report_close,.profile_report_zoon .profile_report_cancel,.profile_report_tip_mask .profile_report_close').on('click', function (e) {
    e.stopPropagation();
    $('.profile_report_zoon').removeClass('active');
    $('.profile_report_tip_mask').removeClass('active');
    $('body').removeClass('hide');
    $('.profile_report').removeClass('active');
    $('#profile_report_info').val('');
    $('#profile_textarea_tip').html('');
    $('.profile_report_zoon input').prop('checked', false);
    $('#profile_report_num').html('0');
    $('.info_tip').remove();
});
$('.main_right .profile_report').on('click', function (e) {
    e.stopPropagation(); checkLoginStatus(); // 每次点击按钮时先检查登录状态
    if (!window.isLoggedIn) {
        login_status();
    } else {
        $(this).toggleClass('active');
        $('.profile_report_zoon').addClass('active');
        $('.profile_report_container').addClass('active');
    }
});
$('#profile_report_info').on('input', function () {
    $('#profile_report_num').html($(this).val().length);
    if ($(this).val().length > 1000) {
        $('#profile_textarea_tip').html(i18n[lang].public_length_characters_1000);
    } else {
        $('#profile_textarea_tip').html('');
    }
});
function profile_report_toast(type, b, c, d) {
    if (type == 'success') {
        $('.profile_report_tip_mask').addClass('suc active');
        setTimeout(function () {
            $('.profile_report_tip_mask').removeClass('suc active');
        }, 2000);
    } else if (type == 'error') {
        $('.profile_report_tip_mask').addClass('err active');
        setTimeout(function () {
            $('.profile_report_tip_mask').removeClass('err active');
        }, 2000);
    };
    if (b) {
        $('.profile_report_tip_mask .title').html(b)
    }
    if (c) {
        $('.profile_report_tip_mask .info').html(c)
    }
};
function profile_report_arguments(role_id, name, nsfw) {
    $('body').toggleClass('hide');
    $('.profile_report_zoon').addClass('active');
    $('#profile_report_form').attr('role_id', role_id);
    $('.profile_report_zoon #profile_report_role').html(name);
    if (nsfw == 1) {
        $('.profile_report_zoon label[for="profile_report_1"]').addClass('hide');
    } else {
        $('.profile_report_zoon label[for="profile_report_1"]').removeClass('hide');
    }
};
$(window).resize(function () {
    setStatus()
});
$(document).on('click', '.profileMetal .profile_metal_item', function (e) {
    e.stopPropagation();
    $(this).addClass('active').siblings().removeClass('active');
    $('.profileMetal .profileMetalInfo').eq($(this).index()).addClass('active').siblings('.profileMetal .profileMetalInfo').removeClass('active');
    $('#profileMetalBtn').attr('attr-id', $(this).attr('attr-id'))
});
$(document).on('click', '.profileMetalMask .close', function (e) {
    e.stopPropagation();
    $('.profileMetalMask').removeClass('active');
    $('.profileMetal').removeClass('active');
});
$(document).on('click', '#profileMetalBtn', function (e) {
    e.stopPropagation(); checkLoginStatus(); // 每次点击按钮时先检查登录状态
    if (!window.isLoggedIn) {
        location.href = `${lang_path}/account/login/`
    } else {
        location.href = `${lang_path}/bonus/?#metal_zoon`+ $(this).attr('attr-id');
    }
});
//复制
function copyToClipboard(text) {
    var textarea = document.createElement('textarea');
    textarea.style.position = 'fixed';
    textarea.style.opacity = 0;
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
};
$('.copy_btn').on('click', function () {
    copyToClipboard($('#share_link').html());
    $(this).addClass('active');
    $(this).parent().siblings('.share_error').addClass('active');
});
//分享
$('.profile_share').on('click', function () {
    $('.share_box').addClass('active');
    $('.profile_mask').addClass('active');
    $('body').addClass('hide_pro');
});
//设置
$('.profile_settings').on('click', function () {
    $('.settings_box').addClass('active');
    $('.profile_mask').addClass('active');
    $('body').addClass('hide_pro');
});
//弹窗逻辑
$('.profile_close').on('click', function () {
    $(this).parent().removeClass('active');
    $('.profile_mask').removeClass('active');
    $('body').removeClass('hide_pro');
});
//返回上一页面
$('.profile .character_back').on('click', function () {
    if (window.history) {
        window.history.go(-1);
    } else {
        window.location.href = host + lang=='en'?'':lang;
    }
});
function checkLoginAndRedirect(url) {
    checkLoginStatus(); // 每次点击按钮时先检查登录状态
    if (!window.isLoggedIn) {
        $('.main_section').append(`<div class="loginRequiredMask">
            <div class="loginRequired">
            <img src="/images/index/logo_pad.svg" class="logo" alt="Logo Pad"/>
                <div class="title">${i18n[lang].public_Login_Required}</div>
                <div class="desc">${i18n[lang].public_In_order}</div>
                <div class="button">${i18n[lang].log_in}</div>
            </div>
        </div>`)
        manage('Popup_Login_View');
    } else {
        location.href = url;
    }
    $('.loginRequiredMask').on('click', function () {

        $('.main_section .loginRequiredMask').remove();
    })
    $('.loginRequired').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
    })
    $('.loginRequiredMask .button').on('click', function (e) {
        manage('Popup_Login_Click');
        location.href = `${lang_path}/account/login/`
    })
};
//关注
$('.profile .profile_follow').on('click', function () {
    if ($(this).attr('class').indexOf('allowed') > -1 && $(this).attr('class').indexOf('active') == -1 && $(this).attr('class').indexOf('fit') == -1) {
        $(this).removeClass('allowed');
        $(this).html('<img src="/images/account/loading.svg" alt="Loading">');
        getAjax(`/api/followUpdate`, {
            "uid": cookie.getcookie('openid'),
            "status": 0
        }).then(res => {
            $(this).addClass('allowed');
            if (res.code == 200) {
                success(i18n[lang].public_Successfully_Unfollow)
                $(this).html(i18n[lang].public_Follow)
                $(this).addClass('active').removeClass('followed');
                setOtherUserInfo();
            } else {
                error('Failed to Unfollow')
                $(this).html(i18n[lang].public_Following)
            }
        });
    } else if ($(this).attr('class').indexOf('allowed') > -1 && $(this).attr('class').indexOf('active') > -1 && $(this).attr('class').indexOf('fit') == -1) {
        $(this).removeClass('allowed');
        $(this).html('<img src="/images/account/loading.svg" alt="Loading">')
        getAjax(`/api/followUpdate`, {
            "uid": cookie.getcookie('openid'),
            "status": 1
        }).then(res => {
            $(this).addClass('allowed');
            if (res.code == 200) {
                success('Successfully  Followed')
                $(this).html(i18n[lang].public_Following)
                $(this).removeClass('active').addClass('followed');
                setOtherUserInfo();
            } else {
                error(i18n[lang].public_Failed_Followed)
                $(this).html(i18n[lang].public_Follow)
            }
        });
    } else if ($(this).attr('class').indexOf('allowed') == -1 && $(this).attr('class').indexOf('fit') >= -1) {
        checkLoginAndRedirect('/account/profile/');
    }
});
//tab 切换
$('.my_card').on('click', function () {
    console.log('11111111111');
    $(this).addClass('active').siblings().removeClass('active');
    $('.chatContent').eq($(this).index()).addClass('active').siblings('.chatContent').removeClass('active');
    setStatus();
    if ($(this).index() == 0) {
        $('.character_select_zoon').addClass('flex_box');
        $('.story_select_zoon').removeClass('flex_box');
    } else if ($(this).index() == 1) {
        $('.story_select_zoon').addClass('flex_box');
        $('.character_select_zoon').removeClass('flex_box');
    } else {
        $('.story_select_zoon').removeClass('flex_box');
        $('.character_select_zoon').removeClass('flex_box');
    }
});
$('.clause_delete .check').on('click', function () {
    $(this).toggleClass('active');
    $(this).siblings('.delete_zoon').find('.delete_btn').toggleClass('fit');
});
//more_introduction
$('.more_introduction').on('click', function () {
    $(this).toggleClass('active');
    $('.profile_introduction').toggleClass('active');
});
if ($(window).width() < 769) {
    $('.ivu-layout').removeClass('scrollLogic').css({ 'overflowY': 'auto', 'width': '100%' });
    $('html').addClass('scrollLogic').addClass('scroll-active').css({ 'overflowY': 'scroll', 'background': '#f5f6f9' });
    $('.layout-header').css({ 'position': 'fixed', 'top': 0, 'zIndex': 99, 'width': '100%', 'box-sizing': 'border-box' });
    defaultDisplayOfScrollbar();
};